export const etkinlikler = [
  {
    "id": "satranc-turnuvasi",
    "title": "Satranç Turnuvası",
    "image": "/files/images/l2510201812331469.jpg",
    "description": "Satranç Turnuvası23 Nisan Ulusal Egemenlik ve Çocuk Bayramı Etkinlikleri Kapsamında yapilan Satranç Turnuvası 7-8-9-10-11-12 yaş ve Açık Kategorilerinde yapıldı. Okulumuz öğrencilerinden Alya ADIGUZEL 10-11-12 yaş 1.si olmuştur.Turnuvaya katılan tüm öğrencilerimizi tebrik ediyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/l264201811552414.jpg",
      "/files/images/l2642018115524108.jpg",
      "/files/images/l2642018132146188.png"
    ],
    "video": ""
  },
  {
    "id": "montessori",
    "title": "Montessori",
    "image": "/files/images/l19102018175327160.JPG",
    "description": "MontessoriMontessori materyalleri; basitten zora, somuttan soyuta aşamalı bir biçimde düzenlenmiş ve çocuğun hatasını görmesine olanak sağlayacak şekilde tasarlanmıştır. Bu sayede öğretmen, çocuğun hatasını söylememekte ve çocuk doğruyu kendi keşfetmektedir.",
    "gallery": [
      "/files/images/l19102018175327160.JPG",
      "/files/images/l19102018175327707.JPG",
      "/files/images/l19102018175427223.JPG",
      "/files/images/l19102018175427723.JPG",
      "/files/images/l19102018175527223.JPG",
      "/files/images/l19102018175527738.JPG",
      "/files/images/l19102018175627285.JPG",
      "/files/images/l19102018175627848.JPG",
      "/files/images/l19102018175727457.JPG",
      "/files/images/l19102018175727957.JPG",
      "/files/images/l19102018175827488.JPG",
      "/files/images/l19102018175927113.JPG",
      "/files/images/l19102018175927644.JPG",
      "/files/images/l19102018175927785.JPG",
      "/files/images/l19102018175927972.JPG",
      "/files/images/l1910201817028129.JPG",
      "/files/images/l1910201817028301.JPG"
    ],
    "video": ""
  },
  {
    "id": "gezegenimizi-taniyalim",
    "title": "Gezegenimizi Tanıyalım",
    "image": "/files/images/l12102018121346330.jpg",
    "description": "Gezegenimizi Tanıyalım3. sınıf öğrencilerimiz Fen Bilimleri dersi kapsamında yer alan ''Gezegenimizi Tanıyalım'' ünitesinde öğrendikleri Dünya'nın katmanlarını oyun hamuruyla modellediler. Hem eğlendiler hem öğrendiler.",
    "gallery": [
      "/files/images/l12102018121346330.jpg",
      "/files/images/l12102018121346486.jpg",
      "/files/images/l12102018121346658.jpg",
      "/files/images/l12102018121346814.jpg",
      "/files/images/l12102018121346986.jpg"
    ],
    "video": ""
  },
  {
    "id": "ip-atlama-senligi",
    "title": "İp Atlama Şenliği",
    "image": "/images2/img2_files/logo.jpg",
    "description": "İp Atlama ŞenliğiVücut şeklini korumak, akciğer kapasitesini ve fiziksel direnci arttırmak gibi sayısız faydası olan en önemli spor etkinliklerinden biri de ip atlama aktivitesidir. İlkokul öğrencilerimizle ip atlama etkinliğimizi, büyük bir mutluluk ve keyifle gerçekleştirdik.",
    "gallery": [],
    "video": "https://www.youtube.com/embed/jMWIEIjUZ7o?ecver=1"
  },
  {
    "id": "okulumda-ilk-gunum",
    "title": "Okulumda İlk Günüm",
    "image": "/files/images/l1092018143042755.jpg",
    "description": "Okulumda İlk Günüm1. sınıflarmız sevgiyle ve heyecanla sınıflarımızı doldurdu, Nice güzelliklerle beraber olmak dileğiyle.",
    "gallery": [],
    "video": "https://www.youtube.com/embed/32CdemK-4uw?ecver=1"
  },
  {
    "id": "sanat-haftasi-resitaller-3-ve-4-siniflarimiz",
    "title": "Sanat Haftası Resitaller 3. ve 4. Sınıflarımız",
    "image": "/files/images/l462018135335730.jpg",
    "description": "Sanat Haftası Resitaller 3. ve 4. SınıflarımızGüney Gelişim Okulları Sanat Haftası kapsamında düzenlenen 3. ve 4. sınıflarımızın resitallerini gerçekleştirdik.  Öğrencilerimizi göstermiş oldukları çaba ve emekten dolayı kutluyor, başarılarının artarak devam etmesini diliyoruz.",
    "gallery": [
      "/files/images/l462018135335730.jpg",
      "/files/images/l462018135335870.jpg",
      "/files/images/l46201813543511.jpg",
      "/files/images/l462018135435167.jpg",
      "/files/images/l462018135435308.jpg",
      "/files/images/l462018135435464.jpg",
      "/files/images/l462018135435620.jpg",
      "/files/images/l462018135435777.jpg",
      "/files/images/l462018135435933.jpg",
      "/files/images/l462018135535105.jpg",
      "/files/images/l462018135535261.jpg",
      "/files/images/l462018135535527.jpg",
      "/files/images/l462018135535751.jpg",
      "/files/images/l462018135535917.jpg",
      "/files/images/l46201813563589.jpg",
      "/files/images/l462018135635230.jpg",
      "/files/images/l462018135635355.jpg",
      "/files/images/l462018135635511.jpg",
      "/files/images/l462018135635667.jpg",
      "/files/images/l462018135635808.jpg",
      "/files/images/l462018135635964.jpg",
      "/files/images/l462018135735105.jpg",
      "/files/images/l462018135735261.jpg",
      "/files/images/l462018135735386.jpg",
      "/files/images/l462018135735542.jpg",
      "/files/images/l462018135735698.jpg",
      "/files/images/l462018135735839.jpg",
      "/files/images/l462018135735995.jpg",
      "/files/images/l462018135835136.jpg",
      "/files/images/l462018135835277.jpg",
      "/files/images/l462018135835433.jpg",
      "/files/images/l462018135835573.jpg",
      "/files/images/l462018135835745.jpg",
      "/files/images/l462018135835917.jpg",
      "/files/images/l46201813593558.jpg",
      "/files/images/l462018135935198.jpg",
      "/files/images/l462018135935355.jpg",
      "/files/images/l462018135935511.jpg",
      "/files/images/l462018135935652.jpg",
      "/files/images/l462018135935823.jpg"
    ],
    "video": "http://dizihitplayer.xyz/player/flex/a0891e8ce7bfbd492ad84afe44121667"
  },
  {
    "id": "mangala-turnuvasi",
    "title": "Mangala Turnuvası",
    "image": "/files/images/l462018104819609.JPG",
    "description": "Mangala TurnuvasıOkulumuzda ilk defa düzenlenen “Mangala Turnuvası”nda dereceye giren ve katılan tüm öğrencilerimizi tebrik ediyoruz.Harika bir turnuvaydı …",
    "gallery": [
      "/files/images/l462018104819609.JPG"
    ],
    "video": ""
  },
  {
    "id": "golf-turnuvasi-dereceleri",
    "title": "Golf Turnuvası Dereceleri",
    "image": "/files/images/l462018101217281.JPG",
    "description": "Golf Turnuvası DereceleriOkulumuzda sınıflar arası düzenlenen “ Golf Turnuvası ”nda dereceye giren ve katılan tüm öğrencilerimizi kutluyoruz.",
    "gallery": [
      "/files/images/l462018101217281.JPG"
    ],
    "video": ""
  },
  {
    "id": "1-ve-2-siniflarimizin-resitalleri",
    "title": "1. ve 2. Sınıflarımızın Resitalleri",
    "image": "/files/images/l285201821189186.JPG",
    "description": "1. ve 2. Sınıflarımızın ResitalleriGüney Gelişim Okulları Sanat Haftası kapsamında düzenlenen etkinliklerimizin ilki olan; 1. ve 2. Sınıf öğrencilerimizin resitalini izledik. Öğrencilerimizin performansları bizi gururlandırdı. Emeklerinize sağlık çocuklar. Sizleri kutluyor, başarılarınızın devamını diliyoruz.",
    "gallery": [
      "/files/images/l285201821189186.JPG",
      "/files/images/l285201821199342.JPG",
      "/files/images/l285201821209436.JPG",
      "/files/images/l285201821219561.JPG",
      "/files/images/l285201821229561.JPG",
      "/files/images/l285201821239732.JPG",
      "/files/images/l285201821249811.JPG",
      "/files/images/l285201821259795.JPG",
      "/files/images/l285201821269857.JPG",
      "/files/images/l285201821279982.JPG",
      "/files/images/l28520182129961.JPG",
      "/files/images/l285201821309279.JPG",
      "/files/images/l285201821319264.JPG",
      "/files/images/l285201821329357.JPG",
      "/files/images/l285201821339435.JPG",
      "/files/images/l285201821349545.JPG",
      "/files/images/l285201821359685.JPG",
      "/files/images/l285201821369717.JPG",
      "/files/images/l285201821379764.JPG",
      "/files/images/l285201821389857.JPG",
      "/files/images/l285201821399921.JPG",
      "/files/images/l28520182141929.JPG",
      "/files/images/l28520182142992.JPG",
      "/files/images/l285201821439139.JPG",
      "/files/images/l285201821449186.JPG",
      "/files/images/l285201821459373.JPG",
      "/files/images/l285201821469435.JPG",
      "/files/images/l285201821479467.JPG",
      "/files/images/l285201821489545.JPG",
      "/files/images/l285201821499592.JPG",
      "/files/images/l285201821509639.JPG",
      "/files/images/l285201821519685.JPG",
      "/files/images/l285201821529732.JPG",
      "/files/images/l285201821539857.JPG",
      "/files/images/l285201821549920.JPG",
      "/files/images/l285201821559920.JPG"
    ],
    "video": "http://dizihitplayer.xyz/player/flex/b29bf6e4798a22fbf5147b9fca252c23"
  },
  {
    "id": "19-mayis-satranc-turnuvasi",
    "title": "19 Mayıs Satranç Turnuvası",
    "image": "/files/images/l255201895837955.jpg",
    "description": "19 Mayıs Satranç TurnuvasıMezitli Belediyesinin 19 Mayıs etkinlikleri kapsamında düzenlediği satranç turnuvasında 2-B sınıfı öğrencilerimizden2. Rahmi Efe Ersoy6. Mehmet Gökçaykutluyor başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/l255201895837955.jpg"
    ],
    "video": ""
  },
  {
    "id": "golf-turnuvasi",
    "title": "Golf Turnuvası",
    "image": "/files/images/l1852018201054452.jpg",
    "description": "Golf TurnuvasıSınıflar arası düzenlediğimiz “ Golf Turnuvası ”nda dereceye giren öğrencilerimizi kutlar, başarılarının devamını dileriz.",
    "gallery": [
      "/files/images/l1852018201054452.jpg",
      "/files/images/l1852018201054609.jpg",
      "/files/images/l1852018201054765.jpg",
      "/files/images/l1852018201054921.jpg",
      "/files/images/l185201820115477.jpg",
      "/files/images/l1852018201154265.jpg",
      "/files/images/l1852018201154421.jpg",
      "/files/images/l1852018201154562.jpg",
      "/files/images/l1852018201154734.jpg",
      "/files/images/l1852018201154874.jpg",
      "/files/images/l185201820125430.jpg",
      "/files/images/l1852018201254155.jpg",
      "/files/images/l1852018201254312.jpg",
      "/files/images/l1852018201254437.jpg",
      "/files/images/l1852018201254593.jpg"
    ],
    "video": "http://dizihitplayer.xyz/player/flex/e79215fc2c84a86527241caf0f438968"
  },
  {
    "id": "okullar-arasi-3x3-minikler-basketbol-musabakalari",
    "title": "Okullar Arası 3x3 Minikler Basketbol Müsabakaları",
    "image": "/files/images/l1852018174017477.jpg",
    "description": "Okullar Arası 3x3 Minikler Basketbol Müsabakaları2017-2018 Eğitim-öğretim yılı okullar arası 3x3 minikler şenliği basketbol müsabakalarında mücadele eden 3. ve 4. Sınıf öğrencilerimizi tebrik eder; başarılarının devamını dileriz.",
    "gallery": [
      "/files/images/l1852018174017477.jpg"
    ],
    "video": ""
  },
  {
    "id": "okullar-arasi-yuzme-turnuvasi",
    "title": "Okullar Arası Yüzme Turnuvası",
    "image": "/files/images/l1852018114947119.jpg",
    "description": "Okullar Arası Yüzme TurnuvasıOkul Sporlarının düzenlediği okullar arası yüzme Mersin Birinciliği turnuvasına katılan öğrencilerimizi tebrik eder, başarılarının devamını dileriz.Defne YAZICI100 m serbest yüzme stilinde 2.100 m sırtüstü yüzme stilinde 2.50 m serbest yüzme stilinde 2.Ahmet Efe ÇELİK50 m sırtüstü yüzme stilinde 1.100 m serbest yüzme stilinde 2.50 m serbest yüzme stilinde 2.",
    "gallery": [
      "/files/images/l1852018114947119.jpg",
      "/files/images/l2452018155314818.jpg"
    ],
    "video": ""
  },
  {
    "id": "vocabulary-parade",
    "title": "VOCABULARY PARADE",
    "image": "/files/images/l115201811649680.JPG",
    "description": "VOCABULARY PARADE5 Haziran Pazartesi ve 6 Haziran Salı günleri İngilizce Bölümünce düzenlenen ' VOCABULARY PARADE' etkinliğinde öğrencilerimiz tasarladıkları renkli ve yaratıcı kostümlerle, kelime bilgilerini eğlenerek ve yaşayarak paylaşma imkanı buldular.On Monday June 5th  and Tuesday June 6th our students were given a great opportunity by the English Department to display their colorful creative costume designs while sharing their word knowledge in our first ever 'Vocabulary Parade'.",
    "gallery": [
      "/files/images/l1462017102758639.jpg",
      "/files/images/l1462017102758953.jpg",
      "/files/images/l1462017102858202.jpg",
      "/files/images/l1462017102858390.jpg",
      "/files/images/l1462017102858561.jpg",
      "/files/images/l1462017102858733.jpg",
      "/files/images/l1462017102858889.jpg"
    ],
    "video": ""
  },
  {
    "id": "hadi-hep-birlikte-yapalim-lets-do-it-together-lass-uns-was-zusammen-machen",
    "title": "“Hadi Hep Birlikte Yapalım” “Let’s Do It Together” “Lass Uns Was Zusammen Machen”",
    "image": "/images2/img2_files/logo.jpg",
    "description": "“Hadi Hep Birlikte Yapalım” “Let’s Do It Together” “Lass Uns Was Zusammen Machen”Okulumuzda 21 Ekim Cumartesi günü 09.30-12.00 saatleri arasında 2. ve 3. Sınıf öğrenci ve velilerimize yönelik“ Hadi Hep Birlikte Yapalım ” etkinliğini düzenledik. Spor, Sanat, Satranç, Akıl Oyunları, Yabancı Dil, Kodlama ve Drama branşlarından oluşan etkinliğimize çocuklarımızla birlikte katılan tüm velilerimize teşekkür ediyoruz.",
    "gallery": [
      "/files/images/l26102017222327845.JPG",
      "/files/images/l26102017222427892.JPG",
      "/files/images/l26102017222527939.JPG",
      "/files/images/l2610201722272779.JPG",
      "/files/images/l26102017222827204.JPG",
      "/files/images/l26102017222927329.JPG",
      "/files/images/l26102017223027423.JPG",
      "/files/images/l26102017223127704.JPG",
      "/files/images/l26102017223227751.JPG",
      "/files/images/l26102017223327829.JPG",
      "/files/images/l26102017223427954.JPG",
      "/files/images/l2610201722362733.JPG",
      "/files/images/l26102017223727142.JPG",
      "/files/images/l26102017223827158.JPG",
      "/files/images/l26102017223927283.JPG",
      "/files/images/l26102017224027392.JPG",
      "/files/images/l26102017224127376.JPG",
      "/files/images/l26102017224227595.JPG",
      "/files/images/l26102017224327642.JPG",
      "/files/images/l26102017224427626.JPG",
      "/files/images/l26102017224527783.JPG",
      "/files/images/l26102017224627798.JPG",
      "/files/images/l26102017224727892.JPG",
      "/files/images/l26102017224827939.JPG",
      "/files/images/l26102017225027111.JPG",
      "/files/images/l26102017225127173.JPG",
      "/files/images/l26102017225227282.JPG",
      "/files/images/l26102017225327470.JPG",
      "/files/images/l26102017225427564.JPG",
      "/files/images/l26102017225527704.JPG",
      "/files/images/l26102017225627816.JPG",
      "/files/images/l26102017225827111.JPG",
      "/files/images/l26102017225927251.JPG",
      "/files/images/l2610201722028329.JPG",
      "/files/images/l2610201722128439.JPG",
      "/files/images/l2610201722228579.JPG"
    ],
    "video": "https://www.youtube.com/embed/-5ikJaSiHpY?ecver=1"
  },
  {
    "id": "teknolojinin-dogru-kullanimi",
    "title": "Teknolojinin Doğru Kullanımı",
    "image": "/files/images/l25201814521975.jpg",
    "description": "Teknolojinin Doğru Kullanımıİlkokul Rehber Öğretmenimizin hazırladığı “ Teknolojinin Doğru Kullanımı, Teknolojinin Yararları ve Zararları, Teknolojinin Nasıl Ölçülü Kullanılması Gerektiği ” konulu sunumu, 1.2.3. ve 4. Sınıf öğrencilerimiz büyük bir keyif ve dikkatle dinlediler.",
    "gallery": [
      "/files/images/l25201814521975.jpg",
      "/files/images/l25201814621350.jpg",
      "/files/images/l25201814621710.jpg"
    ],
    "video": ""
  },
  {
    "id": "becerikli-yapilar",
    "title": "Becerikli Yapılar",
    "image": "/files/images/l264201816235303.jpg",
    "description": "Becerikli Yapılar26 Nisan Perşembe günü sınıflar arası yapılan “ Becerikli Yapılar ” final müsabakalarını 4-B sınıfı öğrencilerimiz kazanmıştır.Öğrencilerimizi tebrik ediyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/l264201816235303.jpg",
      "/files/images/l264201816235396.jpg",
      "/files/images/l264201816235490.jpg",
      "/files/images/l264201816235568.jpg",
      "/files/images/l264201816235662.jpg",
      "/files/images/l264201816235756.jpg",
      "/files/images/l264201816235834.jpg",
      "/files/images/l264201816235928.jpg",
      "/files/images/l26420181624553.jpg"
    ],
    "video": ""
  },
  {
    "id": "satranc-turnuvasi-2",
    "title": "Satranç Turnuvası",
    "image": "/files/images/l264201811552414.jpg",
    "description": "Satranç Turnuvası23 Nisan Ulusal Egemenlik ve Çocuk Bayramı Etkinlikleri Kapsamında yapilan Satranç Turnuvası 7-8-9-10-11-12 yaş ve Açık Kategorilerinde yapıldı. Okulumuz öğrencilerinden Alya ADIGUZEL 10-11-12 yaş 1.si olmuştur.Turnuvaya katılan tüm öğrencilerimizi tebrik ediyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/l264201811552414.jpg",
      "/files/images/l2642018115524108.jpg",
      "/files/images/l2642018132146188.png"
    ],
    "video": ""
  },
  {
    "id": "23-nisan-ulusal-egemenlik-ve-cocuk-bayrami",
    "title": "23 Nisan Ulusal Egemenlik ve Çocuk Bayramı",
    "image": "/files/images/l25201819314089.JPG",
    "description": "23 Nisan Ulusal Egemenlik ve Çocuk Bayramı23 Nisan Ulusal Egemenlik ve Çocuk Bayramı törenimizi velilerimizle birlikte bütün okul olarak çok güzel bir şenlikle taçlandırdık. Bu töreni şanına yakışır şekilde gerçekleştirmemiz için büyük emek sarf eden öğrencilerimize, öğretmenlerimize ve katılan tüm velilerimize teşekkür ederiz.",
    "gallery": [
      "/files/images/l25201819314089.JPG",
      "/files/images/l25201820214468.JPG",
      "/files/images/l25201820314515.JPG",
      "/files/images/l25201820414562.JPG",
      "/files/images/l25201820514593.JPG",
      "/files/images/l25201820614687.JPG",
      "/files/images/l25201820714734.JPG",
      "/files/images/l25201820814781.JPG",
      "/files/images/l25201820914843.JPG",
      "/files/images/l252018201014937.JPG",
      "/files/images/l252018201114937.JPG",
      "/files/images/l252018201214953.JPG",
      "/files/images/l252018201314921.JPG",
      "/files/images/l252018201414937.JPG",
      "/files/images/l252018201514968.JPG",
      "/files/images/l25201820171415.JPG",
      "/files/images/l252018201714999.JPG",
      "/files/images/l252018201814968.JPG",
      "/files/images/l252018201914999.JPG",
      "/files/images/l252018202114109.JPG",
      "/files/images/l252018202214140.JPG",
      "/files/images/l252018202314187.JPG",
      "/files/images/l252018202414202.JPG",
      "/files/images/l252018202514234.JPG",
      "/files/images/l252018202614312.JPG",
      "/files/images/l252018202714452.JPG",
      "/files/images/l252018202814437.JPG",
      "/files/images/l252018202914437.JPG",
      "/files/images/l252018203014499.JPG",
      "/files/images/l252018203114593.JPG",
      "/files/images/l252018203214749.JPG",
      "/files/images/l252018203314796.JPG",
      "/files/images/l252018203414890.JPG",
      "/files/images/l252018203514952.JPG",
      "/files/images/l25201820371430.JPG",
      "/files/images/l25201820381493.JPG",
      "/files/images/l25201820391493.JPG",
      "/files/images/l252018204014280.JPG",
      "/files/images/l252018204114327.JPG",
      "/files/images/l252018204214452.JPG",
      "/files/images/l252018204314484.JPG",
      "/files/images/l252018204414499.JPG",
      "/files/images/l252018204514577.JPG",
      "/files/images/l252018204614562.JPG",
      "/files/images/l252018204714718.JPG",
      "/files/images/l252018204814859.JPG",
      "/files/images/l252018204914905.JPG",
      "/files/images/l252018205014937.JPG",
      "/files/images/l25201820521477.JPG",
      "/files/images/l252018205314124.JPG",
      "/files/images/l252018205414124.JPG",
      "/files/images/l252018205514171.JPG",
      "/files/images/l252018205614327.JPG",
      "/files/images/l252018205714359.JPG",
      "/files/images/l252018205814405.JPG",
      "/files/images/l252018205914437.JPG",
      "/files/images/l25201820015452.JPG",
      "/files/images/l25201820115499.JPG",
      "/files/images/l25201820215499.JPG",
      "/files/images/l25201820315546.JPG",
      "/files/images/l25201820415562.JPG",
      "/files/images/l25201820515671.JPG",
      "/files/images/l25201820615780.JPG",
      "/files/images/l25201820715952.JPG",
      "/files/images/l2520182091562.JPG",
      "/files/images/l25201820101577.JPG",
      "/files/images/l25201820111593.JPG",
      "/files/images/l25201820121577.JPG",
      "/files/images/l252018201315155.JPG",
      "/files/images/l252018201415140.JPG",
      "/files/images/l25201820151593.JPG",
      "/files/images/l25201820161546.JPG",
      "/files/images/l252018201715171.JPG",
      "/files/images/l252018201815202.JPG",
      "/files/images/l252018201915311.JPG",
      "/files/images/l252018202015452.JPG",
      "/files/images/l252018202215999.JPG",
      "/files/images/l252018202415218.JPG",
      "/files/images/l252018202515515.JPG",
      "/files/images/l252018202615733.JPG",
      "/files/images/l252018202715936.JPG"
    ],
    "video": "http://dizihitplayer.xyz/player/flex/09acb18dae3540a16c86454f5bbe49e4"
  },
  {
    "id": "biatlonmodern-pentatlon-yarismasi",
    "title": "Biatlon-Modern Pentatlon Yarışması",
    "image": "/files/images/l1242018164311.jpg",
    "description": "Biatlon-Modern Pentatlon Yarışması6 Nisan Cuma günü okullar arası düzenlenen Biatlon-Modern Pentatlon yarışmasında;Artun Ballı Mersin 4.süEge Erdal Mert Mersin 5.si olmuştur.Öğrencilerimizi kutlar, başarılarının devamını dileriz.",
    "gallery": [
      "/files/images/l1242018164311.jpg"
    ],
    "video": ""
  },
  {
    "id": "mersin-tenis-yelken-ve-yuzme-kulubu",
    "title": "Mersin Tenis, Yelken ve Yüzme Kulübü",
    "image": "/files/images/l104201814287247.jpg",
    "description": "Mersin Tenis, Yelken ve Yüzme KulübüMersin Tenis, Yelken ve Yüzme Kulübünün düzenlemiş olduğu tenis turnuvasında derece alan öğrencilerimizi kutlar başarılarının devamını dileriz.",
    "gallery": [
      "/files/images/l104201814287247.jpg"
    ],
    "video": ""
  },
  {
    "id": "first-lego-league-junior-fll-jr-20172018-sezonu-mersin-fuari",
    "title": "FIRST® LEGO® League Junior (FLL® Jr.)  2017-2018 Sezonu Mersin Fuarı",
    "image": "/files/images/l942018101934368.jpg",
    "description": "FIRST® LEGO® League Junior (FLL® Jr.)  2017-2018 Sezonu Mersin FuarıOkulumuzun ilk Robotik Takımı \"Hydrobots\" Mersin Üniversitesinde düzenlenen Minik Bilim Kahramanları Buluşuyor fuarında yaptıkları harika çalışmayla ziyaretçilerden büyük beğeni topladı. Fuarın en ilginç ve yaratıcı çalışmalarından birini tasarlayan öğrencilerimizi tebrik ediyoruz. Bundan sonraki projeleri heyecanla bekliyoruz.",
    "gallery": [
      "/files/images/l942018101934368.jpg",
      "/files/images/l942018101934446.jpg",
      "/files/images/l942018101934634.jpg",
      "/files/images/l942018101934743.jpg",
      "/files/images/l942018101934852.jpg",
      "/files/images/l942018101934977.jpg",
      "/files/images/l94201810203471.jpg",
      "/files/images/l942018102034118.jpg",
      "/files/images/l942018102034165.jpg",
      "/files/images/l942018102034212.jpg",
      "/files/images/l942018101438632.jpg",
      "/files/images/l9420181015387.jpg",
      "/files/images/l942018101538492.jpg",
      "/files/images/l94201810641522.jpg",
      "/files/images/l942018104351238.jpg",
      "/files/images/l164201813145474.JPG"
    ],
    "video": ""
  },
  {
    "id": "719-yas-aile-egitimi-ilkokul-1-etap",
    "title": "7-19 YAŞ AİLE EĞİTİMİ İLKOKUL 1. ETAP",
    "image": "/files/images/l242018235228294.jpg",
    "description": "7-19 YAŞ AİLE EĞİTİMİ İLKOKUL 1. ETAP1. OTURUM “ERGENİ TANIMAK”BU OTURUMUN GENEL AMAÇLARIBu oturumu tamamlayan katılımcılarımız,-Ergenlik dönemindeki gelişim alanlarını tanırlar.-Ergenlik dönemindeki değişimleri fark ederler.-Ergenlik döneminde hem çocuklara hem de yakın çevresine nasıl destek olabileceklerinin farkına varırlar.-Ergenlik döneminde gelişim dönemlerini desteklemeye yönelik bilgi ve beceriler kazanırlar.-Velilerimizin yoğun katılımıyla, paylaşıma dayalı bir ortamda, etkinliklerimizle zenginleştirilen oturumumuz keyifli ve verimli bir şekilde tamamlanmıştır.7-19 YAŞ AİLE EĞİTİMİ 2. OTURUM “İLETİŞİM KURMAK”BU OTURUMUN GENEL AMAÇLARIBu oturumu tamamlayan katılımcılarımız,-İletişimle ilgili temel bilgiler edinirler.-İletişimde zamanı etkin olarak düzenleyebilirler.-Ergen çocuklarına yönelik kullanabilecekleri iletişim becerilerini geliştirirler.-İlk oturumumuzla bağlantılı olarak yürüttüğümüz bu oturumda, oluşan enerji  grup dinamiğimizin de etkisiyle, eğlenceli etkinliklerimizle farkındalık dolu bir oturum tamamladık.7-19 YAŞ AİLE EĞİTİMİ 3. OTURUM “BİRLİKTE BÜYÜMEK”BU OTURUMUN GENEL AMAÇLARIBu oturumu tamamlayan katılımcılarımız,-Anne baba ve eş olarak aile içindeki rollerinin farkına varırlar.-Sağlıklı bir ilişki için gerekli becerileri kazanırlar.Aile yaşam döngülerimizin bir süreç olup, her ailenin zamanla büyüyüp, farklılaşıp geliştiğini ve ilişkilerimizdeki temel ihtiyaçlarımızı göz ardı etmeden bu süreci tamamlamanın önemini konuşarak sağlıklı aile gelişimi için paylaşımda bulunduk.7-19 YAŞ AİLE EĞİTİMİ 4. OTURUM “ANNE-BABA TUTUTMLARI”BU OTURUMUN GENEL AMAÇLARIBu oturumu tamamlayan katılımcılarımız-Aile içi farklı tutumların kendileri ve çocuk­ları üzerindeki etkisinin farkında olurlar.-Sağlıklı bir ilişki için yetkin tutum becerisi geliştirirler.Birinci grubumuzun son oturumu olan “Anne-Baba Tutumları” nı velilerimizin yoğun katılımıyla tamamladık. İçeriğin verimli işlenmesinin yanı sıra oluşan grup dinamiği ve anne babaların paylaşım dolu kurdukları güçlü ilişkiler bizleri çok mutlu etti. Siz velilerimizle başka eğitimlerde buluşmak üzere…",
    "gallery": [
      "/files/images/l242018235228294.jpg",
      "/files/images/l242018235228450.jpg",
      "/files/images/l242018235228575.jpg",
      "/files/images/l242018235228654.jpg",
      "/files/images/l242018235228747.jpg",
      "/files/images/l94201813929548.jpg",
      "/files/images/l94201813929642.jpg",
      "/files/images/l94201813929704.jpg",
      "/files/images/l94201813929782.jpg",
      "/files/images/l94201813929861.jpg",
      "/files/images/l94201813929939.jpg",
      "/files/images/l9420181310291.jpg",
      "/files/images/l94201813102979.jpg",
      "/files/images/l942018131029158.jpg",
      "/files/images/l942018131029220.jpg"
    ],
    "video": "https://www.youtube.com/embed/IHG2AwwZPG8?ecver=1"
  },
  {
    "id": "saglikli-ve-dengeli-beslenme",
    "title": "Sağlıklı ve Dengeli Beslenme",
    "image": "/files/images/l2932018165858361.jpg",
    "description": "Sağlıklı ve Dengeli Beslenme“Ben Yemek Seçmem Projesi” kapsamında okul çağındaki çocuklarımızın sağlıklı beslenme davranışlarının kazandırılması amacıyla uzman diyetisyen Sayın Seda KOÇAR tarafından eğitim çalışması yapılmıştır. Etkileyici sunum için teşekkür ediyoruz.",
    "gallery": [
      "/files/images/l2932018165858361.jpg",
      "/files/images/l2932018165858502.jpg",
      "/files/images/l2932018165858611.jpg"
    ],
    "video": ""
  },
  {
    "id": "golf-gunleri",
    "title": "GOLF GÜNLERİ",
    "image": "/files/images/l283201884144509.jpg",
    "description": "GOLF GÜNLERİGelişim öğrencileri sporun her dalını deneyimliyor. 12 Mart Pazartesi günü ortaokul öğrencilerimiz arasında başlayan  “ Golf Turnuvası ” devam ediyor. Çocuklarımızın fiziksel gelişimini destekleyen, karar verme , sorumluluk  duygusunu geliştiren, zeka gelişimine katkı sağlayan  golf derslerinde keyifli vakit geçiriyorlar...",
    "gallery": [
      "/files/images/l283201884144509.jpg",
      "/files/images/l283201884144619.jpg",
      "/files/images/l28320181316680.jpg",
      "/files/images/l28320181316805.jpg",
      "/files/images/l1642018132540538.jpg",
      "/files/images/l1642018132540663.jpg",
      "/files/images/l1642018132540788.jpg",
      "/files/images/l1642018132540898.jpg"
    ],
    "video": ""
  },
  {
    "id": "gitar-kulubu",
    "title": "Gitar Kulübü",
    "image": "/images2/img2_files/logo.jpg",
    "description": "Gitar KulübüGitar Kulübü öğrencilerimiz ve aileleri ile orkestra kurarak Gitar, Melalofon, Ksilofon ve Boomwhackers (ses boruları) çaldık. Çok eğitici ve eğlenceli bir etkinlik daha yaptık. Bir sonraki etkinliğimizde görüşmek üzere...",
    "gallery": [],
    "video": "https://www.youtube.com/embed/pKVxMhiu_wE?ecver=1"
  },
  {
    "id": "art-workshop-kulubu",
    "title": "Art Workshop Kulübü",
    "image": "/images2/img2_files/logo.jpg",
    "description": "Art Workshop KulübüArt Workshop Kulübü öğrencilerimiz aileleri ile birlikte dikiş nakışla duvar süslemesi ve oyuncaklar yaptılar. Eğitici eğlenceli bir etkinliğimizi daha gerçekleştirdik. Bir sonraki etkinliğimizde görüşmek üzere...",
    "gallery": [],
    "video": "https://www.youtube.com/embed/xRoeYXbOlDQ?ecver=1"
  },
  {
    "id": "yaslilar-haftasi",
    "title": "YAŞLILAR HAFTASI",
    "image": "/files/images/l2232018172858635.jpg",
    "description": "YAŞLILAR HAFTASIYaşlılar Haftası kapsamında okulumuzu ziyaret eden ve söyleşimizde o müthiş hayat deneyimlerinden bir parça aktaran konuklarımıza teşekkürler...",
    "gallery": [
      "/files/images/l2232018172858635.jpg",
      "/files/images/l2232018172858729.jpg",
      "/files/images/l2232018172858807.jpg",
      "/files/images/l2232018172858885.jpg"
    ],
    "video": ""
  },
  {
    "id": "kodlama-ve-robotik-veli-atolyesi",
    "title": "KODLAMA VE ROBOTİK VELİ ATÖLYESİ",
    "image": "/files/images/l1832018225250315.jpg",
    "description": "KODLAMA VE ROBOTİK VELİ ATÖLYESİ17 Mart Cumartesi günü 4. Sınıf öğrencilerimizin ve velilerimizin katıldığı \"Kodlama-Robotik Veli Atölyesi\" etkinliğini gerçekleştirdik. Lego Education WeDO setlerini kullandığımız etkinlikte öğrencilerimiz tasarladıkları robotları harekete geçirdiler.",
    "gallery": [
      "/files/images/l1832018225250315.jpg",
      "/files/images/l1832018225250424.jpg",
      "/files/images/l1832018225250534.JPG",
      "/files/images/l1832018225350503.png"
    ],
    "video": "https://www.youtube.com/embed/s3lT-KOb_uI?ecver=1"
  },
  {
    "id": "tirmanma-egitimi",
    "title": "Tırmanma Eğitimi",
    "image": "/files/images/l1232018235311896.jpg",
    "description": "Tırmanma EğitimiBeden Eğitimi derslerimizde çocuklarımızın baskı altında karar verebilme, planlama yapabilme, kendine güven duygusunu geliştirebilme gibi yeteneklerine olumlu katkı sağlayacak tırmanma etkinliklerine başladık.Adım adım zirveye…",
    "gallery": [
      "/files/images/l1232018235311896.jpg",
      "/files/images/l1232018235311959.jpg",
      "/files/images/l123201823541152.jpg",
      "/files/images/l133201813104346.jpg",
      "/files/images/l1432018101653147.jpg",
      "/files/images/l1432018104553147.jpg",
      "/files/images/l1432018123050547.jpg"
    ],
    "video": "https://www.youtube.com/embed/nzOIW6ColRw?ecver=1"
  },
  {
    "id": "mersin-okul-sporlari-satranc-yarismasi",
    "title": "MERSİN OKUL SPORLARI SATRANÇ YARIŞMASI",
    "image": "/files/images/l2022018111754467.jpg",
    "description": "MERSİN OKUL SPORLARI SATRANÇ YARIŞMASI2017-2018 Mersin Okul Sporları Satranç Yarışmaları 17-18 Şubat tarihlerinde oynandı. Toplamda 99 takımın mücadele ettiği turnuvaya 3 kategoride 7 takımla katıldık.Dereceğe giren takımlarımız ve oyuncuları;1) Minikler Genel Kategorisinde 3. olan takımımız                       2) Minikler Kızlar Kategorisinde 2. olan takımımız-Umut Cem ÇİÇEK                                                                         -Bade BAKIREZEN-Rüzgar Efe YILDIRIM                                                                    -Alya ADIGÜZEL-Utku Eren TÜRKÖZ                                                                       -Bade TÜTÜNCÜ-Deniz ZANTUR                                                                              -Defne ÖZTÜRK-Yiğit KÖPRÜLÜKatılan bütün sporcularımızı tebrik ediyoruz ve başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/l2022018111754467.jpg",
      "/files/images/l2022018111754561.jpg"
    ],
    "video": ""
  },
  {
    "id": "gorsel-sanatlar-sergi",
    "title": "Görsel Sanatlar Sergi",
    "image": "/files/images/l1422018142918260.jpg",
    "description": "Görsel Sanatlar SergiSayın velilerimiz 4. Sınıf öğrencilerimizden Olcay Ece Akyılmaz ve Lina Bereketbulur Bilsem Okullarında açılan Pop-Art Resim Sanatı Sergisinde yaptıkları başarılı çalışmalarla bizleri gururlandırdılar. Öğrencilerimize çok teşekkür ediyoruz.",
    "gallery": [
      "/files/images/l1422018142918260.jpg",
      "/files/images/l1422018142918338.jpg",
      "/files/images/l1422018142918400.jpg",
      "/files/images/l1422018142918525.jpg"
    ],
    "video": ""
  },
  {
    "id": "here-to-help",
    "title": "‘’HERE to HELP’’",
    "image": "/files/images/l1222018131850328.jpg",
    "description": "‘’HERE to HELP’’İngilizce bölümümüz tarafından her yıl olduğu gibi bu yılda‘’Here to Help’’adlı proje çalışması yapılmıştır. Projede ilkokul 4. sınıf öğrencilerimiz alt sınıflardaki öğrencilere ders aralarında çeşitli konularda yardım ettiler. Oyunlar oynattılar, okuma çalışması yaptılar. Birlikte eğlenceli vakit geçirdiler.Our English department organized a Project called ’Here to Help’’. During the Project, our 4 th graders helped young learners in various ways.They played games, did reading hours and had fun together.",
    "gallery": [
      "/files/images/l1222018131850328.jpg",
      "/files/images/l1222018131850718.jpg",
      "/files/images/l1222018131950234.jpg",
      "/files/images/l1222018131950687.jpeg",
      "/files/images/l1222018131950781.jpeg",
      "/files/images/l1222018131950875.jpeg",
      "/files/images/l1222018131950968.jpeg",
      "/files/images/l122201813205046.jpeg"
    ],
    "video": ""
  },
  {
    "id": "mersin-ritmik-jimnastik-musabakalari",
    "title": "MERSİN RİTMİK JİMNASTİK MÜSABAKALARI",
    "image": "/files/images/l1612018224636504.jpg",
    "description": "MERSİN RİTMİK JİMNASTİK MÜSABAKALARIMersin ilinde düzenlenen Okullar Arası Ritmik Jimnastik Müsabakasında okul takımımız Mersinbirincisiolmuştur.Mersin ilinde düzenlenen Okullar Arası Ritmik Jimnastik Müsabakasındaİkinci Sınıf ÖğrencimizDuru EKİZMersin ikincisi olmuştur.Mersin ilinde düzenlenen Okullar ArasıArtistik JimnastikMüsabakasında okul takımımız Mersindördüncüsüolmuştur.",
    "gallery": [
      "/files/images/l1612018224636504.jpg",
      "/files/images/l1612018224636614.jpg",
      "/files/images/l161201822473636.jpg",
      "/files/images/l1612018224736145.jpg",
      "/files/images/l1612018224736254.jpg",
      "/files/images/l1612018224736317.jpg"
    ],
    "video": ""
  },
  {
    "id": "arkadaslik-haftasi-5-gun",
    "title": "ARKADAŞLIK HAFTASI 5. GÜN",
    "image": "/files/images/l18122017101428324.JPG",
    "description": "ARKADAŞLIK HAFTASI 5. GÜN11-15 ARALIK Arkadaşlık Haftası kapsamında ilkokul öğrencilerimizle birlikte haftanın kapanış programı için bir araya geldik.Jimnastik Kulübü, Drama Kulübü, İlkokul Müzik Korosu, Dans Kulübü olarak öğrencilerimizin gösterilerini keyifle izledik.",
    "gallery": [
      "/files/images/l18122017101428324.JPG",
      "/files/images/l18122017101528402.JPG",
      "/files/images/l18122017101628433.JPG",
      "/files/images/l18122017101728527.JPG",
      "/files/images/l18122017101828574.JPG",
      "/files/images/l18122017101928683.JPG",
      "/files/images/l18122017102028871.JPG"
    ],
    "video": "https://www.youtube.com/embed/-K4HhgLZVDI?ecver=1"
  },
  {
    "id": "arkadaslik-haftasi-4-gun",
    "title": "ARKADAŞLIK HAFTASI 4. GÜN",
    "image": "/files/images/l1512201719557182.png",
    "description": "ARKADAŞLIK HAFTASI 4. GÜNArkadaşlık haftası kapsamında Rehber Öğretmenimiz eşliğinde çocuklarımızla birlikte sınıfta etkinlikler yapıldı. Çocuklarımız yapılan etkinlikleri ‘Arkadaşlık Anısı’ olarak birbirlerine hediye ettiler.",
    "gallery": [
      "/files/images/l1512201719557182.png",
      "/files/images/l1512201719557307.png",
      "/files/images/l1512201719557432.png",
      "/files/images/l1512201719557557.png",
      "/files/images/l1512201719557682.png",
      "/files/images/l1512201719557791.png",
      "/files/images/l1512201719557901.png",
      "/files/images/l151220171965726.png",
      "/files/images/l1512201719657151.png",
      "/files/images/l1512201719657260.png",
      "/files/images/l1512201719657369.png",
      "/files/images/l1512201719657448.png",
      "/files/images/l1512201719657541.png",
      "/files/images/l1512201719657635.png",
      "/files/images/l1512201719657729.png",
      "/files/images/l1512201719657838.png"
    ],
    "video": ""
  },
  {
    "id": "arkadaslik-haftasi-3-gun",
    "title": "ARKADAŞLIK HAFTASI 3. GÜN",
    "image": "/files/images/l13122017144210649.JPG",
    "description": "ARKADAŞLIK HAFTASI 3. GÜNÖzel Güney Gelişim İlkokulu olarak 13 Aralık Çarşamba günü sınıflarımızın \"Arkadaşlık Ağaçları\"nı diktik.Arkadaşlıklarının da ağaçlar gibi kalıcı olması ve dünyayı iyileştirmesi dileğiyle...",
    "gallery": [
      "/files/images/l13122017144210649.JPG",
      "/files/images/l13122017144310821.JPG",
      "/files/images/l13122017144410962.JPG",
      "/files/images/l1312201714461055.JPG",
      "/files/images/l13122017144710243.JPG",
      "/files/images/l13122017144810462.JPG",
      "/files/images/l13122017144910524.JPG",
      "/files/images/l13122017145010633.JPG",
      "/files/images/l13122017145110680.jpg",
      "/files/images/l1312201717441206.JPG",
      "/files/images/l1312201717451300.JPG",
      "/files/images/l1312201717461393.JPG",
      "/files/images/l1312201717471393.JPG",
      "/files/images/l1312201717481487.JPG",
      "/files/images/l1312201717491675.JPG",
      "/files/images/l1312201717501753.JPG",
      "/files/images/l1312201717511925.JPG",
      "/files/images/l131220171753119.JPG",
      "/files/images/l1312201717541237.JPG",
      "/files/images/l1312201717551315.JPG",
      "/files/images/l1312201717508550.jpg",
      "/files/images/l1312201717508675.jpg",
      "/files/images/l1312201717508753.jpg",
      "/files/images/l1312201717508847.jpg",
      "/files/images/l1312201717508925.jpg",
      "/files/images/l131220171751819.jpg",
      "/files/images/l1312201717518144.jpg",
      "/files/images/l1312201717518269.jpg",
      "/files/images/l1312201717518410.jpg"
    ],
    "video": ""
  },
  {
    "id": "arkadaslik-haftasi-2-gun",
    "title": "ARKADAŞLIK HAFTASI 2. GÜN",
    "image": "/files/images/l12122017195921200.jpg",
    "description": "ARKADAŞLIK HAFTASI 2. GÜNÖzel Güney Gelişim İlkokulu olarak 12 Aralık Salı günü Rehberlik servisi tarafından \"Arkadaşını Ne Kadar Tanıyorsun?\" etkinlik kartları hazırlandı.Öğrencilerimiz etkinlik kartlarını keyifle hazırladılar ve birbirilerine armağan ettiler.Güzel geçen bir arkadaşlık günü sonrasında çocuklar arkadaşlığın ne kadar değerli olduğunu daha iyi anladılar.",
    "gallery": [
      "/files/images/l12122017195921200.jpg",
      "/files/images/l12122017195921278.jpg"
    ],
    "video": ""
  },
  {
    "id": "arkadaslik-haftasi-1-gun",
    "title": "ARKADAŞLIK HAFTASI 1. GÜN",
    "image": "/files/images/l1212201717164473.jpg",
    "description": "ARKADAŞLIK HAFTASI 1. GÜN(11-15 Aralık) Arkadaşlık Haftamız güzel etkinliklerle başladı…Özel Güney Gelişim İlkokulu olarak 11 Aralık Pazartesi günü “Arkadaşlık Haftası” kapsamında Rehber Öğretmenimiz Dilek Çetin’in hazırladığı sunumu, öğrencilerimiz keyifle dinledi.Sunum sonrasında öğrencilerimiz öğret<<<menleri eşliğinde “Arkadaşlığın Önemi” ile ilgili animasyon filmini izlediler.",
    "gallery": [
      "/files/images/l1212201717164473.jpg",
      "/files/images/l1212201717164598.jpg"
    ],
    "video": ""
  },
  {
    "id": "spelling-bee",
    "title": "SPELLING BEE",
    "image": "/files/images/l412201719745457.jpg",
    "description": "SPELLING BEEİngilizce kelime öğrenimini eğlenceli bir şekilde aktarmamızı sağlayan, her yıl bölümümüz tarafından düzenlenen SPELLING BEE adlı heceleme yarışması bu yılda 1 Aralık 2017’ de düzenlendi. 4. Sınıf öğrencilerimiz yarışmacıyken, 3.sınıf öğrencilerimiz dinleyiciydi. Yarışmaya katılan tüm öğrencilerimizi gösterdikleri performanstan dolayı tebrik ediyoruz.To add fun and interest to our English learning program our English Department has once again organized another terrific SPELLING BEE contest. While our grade 4 contestants competed to be the winner, the one to spell the most correct English words, our grade 3 students cheered and played along from their seats. We applaud each and every one of the contestants for their proper sportsmanship and hard work.",
    "gallery": [
      "/files/images/l412201719745457.jpg",
      "/files/images/l412201719745942.jpg",
      "/files/images/l412201719845254.jpg",
      "/files/images/l412201719845723.jpg",
      "/files/images/l412201719945224.jpg",
      "/files/images/l412201719945707.jpg",
      "/files/images/l4122017191045176.jpg",
      "/files/images/l4122017191045676.jpg"
    ],
    "video": ""
  },
  {
    "id": "sihirli-dunya-muzikaline-gittik",
    "title": "Sihirli Dünya müzikaline gittik",
    "image": "/files/images/l2411201791015512.jpeg",
    "description": "Sihirli Dünya müzikaline gittik",
    "gallery": [
      "/files/images/l2411201791015512.jpeg",
      "/files/images/l2411201791015637.jpeg",
      "/files/images/l2411201791015746.jpeg",
      "/files/images/l2411201791015855.jpeg"
    ],
    "video": ""
  },
  {
    "id": "golf-gunleri",
    "title": "GOLF GÜNLERİ",
    "image": "/files/images/l310201711644379.JPG",
    "description": "GOLF GÜNLERİGelişim öğrencileri sporun her dalını deneyimliyor. 12 Mart Pazartesi günü ortaokul öğrencilerimiz arasında başlayan  “ Golf Turnuvası ” devam ediyor. Çocuklarımızın fiziksel gelişimini destekleyen, karar verme , sorumluluk  duygusunu geliştiren, zeka gelişimine katkı sağlayan  golf derslerinde keyifli vakit geçiriyorlar...",
    "gallery": [
      "/files/images/l283201884144509.jpg",
      "/files/images/l283201884144619.jpg",
      "/files/images/l28320181316680.jpg",
      "/files/images/l28320181316805.jpg",
      "/files/images/l1642018132540538.jpg",
      "/files/images/l1642018132540663.jpg",
      "/files/images/l1642018132540788.jpg",
      "/files/images/l1642018132540898.jpg"
    ],
    "video": ""
  },
  {
    "id": "okulumda-ilk-gunum",
    "title": "Okulumda İlk Günüm",
    "image": "/images2/img2_files/logo.jpg",
    "description": "Okulumda İlk Günüm1. sınıflarmız sevgiyle ve heyecanla sınıflarımızı doldurdu, Nice güzelliklerle beraber olmak dileğiyle.",
    "gallery": [],
    "video": "https://www.youtube.com/embed/32CdemK-4uw?ecver=1"
  },
  {
    "id": "vocabulary-parade",
    "title": "VOCABULARY PARADE",
    "image": "/files/images/l1462017102758639.jpg",
    "description": "VOCABULARY PARADE5 Haziran Pazartesi ve 6 Haziran Salı günleri İngilizce Bölümünce düzenlenen ' VOCABULARY PARADE' etkinliğinde öğrencilerimiz tasarladıkları renkli ve yaratıcı kostümlerle, kelime bilgilerini eğlenerek ve yaşayarak paylaşma imkanı buldular.On Monday June 5th  and Tuesday June 6th our students were given a great opportunity by the English Department to display their colorful creative costume designs while sharing their word knowledge in our first ever 'Vocabulary Parade'.",
    "gallery": [
      "/files/images/l1462017102758639.jpg",
      "/files/images/l1462017102758953.jpg",
      "/files/images/l1462017102858202.jpg",
      "/files/images/l1462017102858390.jpg",
      "/files/images/l1462017102858561.jpg",
      "/files/images/l1462017102858733.jpg",
      "/files/images/l1462017102858889.jpg"
    ],
    "video": ""
  },
  {
    "id": "4b--sinifi-ogrencileri--stone-soup--ve--cinderella--adli-ingilizce-tiyatro",
    "title": "4-B  sınıfı öğrencileri  Stone Soup  ve  Cinderella  adlı İngilizce tiyatro",
    "image": "/files/images/l862017135342848.JPG",
    "description": "4-B  sınıfı öğrencileri  Stone Soup  ve  Cinderella  adlı İngilizce tiyatroOkulumuzun 4-B sınıfı öğrencileri \"Stone Soup \" ve \"Cinderella\" adlı İngilizce tiyatro oyunlarıyla sene sonunu başarıyla tamamlamışlardır. Tüm öğrencilerimizi kutlarız.Our students in the 4-B  classes successfully performed two plays entitled \" Stone Soup \" and \"Cinderella\". Congratulations for their achievement.",
    "gallery": [
      "/files/images/l862017135342848.JPG",
      "/files/images/l862017135642630.JPG",
      "/files/images/l862017135942786.JPG",
      "/files/images/l86201713143380.JPG",
      "/files/images/l862017134435.JPG",
      "/files/images/l86201713743255.JPG",
      "/files/images/l862017131043489.JPG",
      "/files/images/l862017131343505.JPG",
      "/files/images/l8620171316435.JPG",
      "/files/images/l862017131843520.JPG",
      "/files/images/l862017132043786.JPG",
      "/files/images/l862017132343864.JPG",
      "/files/images/l86201713274336.JPG",
      "/files/images/l862017132943989.JPG",
      "/files/images/l862017133243349.JPG",
      "/files/images/l862017133443911.JPG"
    ],
    "video": ""
  },
  {
    "id": "4a--sinifi-ogrencileri--stone-soup--ve--cinderella--adli-ingilizce-tiyatro",
    "title": "4-A  sınıfı öğrencileri  Stone Soup  ve  Cinderella  adlı İngilizce tiyatro",
    "image": "/files/images/l862017133816892.JPG",
    "description": "4-A  sınıfı öğrencileri  Stone Soup  ve  Cinderella  adlı İngilizce tiyatroOkulumuzun 4-A  sınıfı öğrencileri \"Stone Soup \" ve \"Cinderella\" adlı İngilizce tiyatro oyunlarıyla sene sonunu başarıyla tamamlamışlardır. Tüm öğrencilerimizi kutlarız.Our students in the 4-A  classes successfully performed two plays entitled \" Stone Soup \" and \"Cinderella\".  Congratulations for their achievement.",
    "gallery": [
      "/files/images/l862017133816892.JPG",
      "/files/images/l862017134016251.JPG",
      "/files/images/l862017134216970.JPG",
      "/files/images/l862017134516954.JPG",
      "/files/images/l862017134816517.JPG",
      "/files/images/l862017135116517.JPG",
      "/files/images/l862017135416736.JPG",
      "/files/images/l862017135716924.JPG",
      "/files/images/l86201713017689.JPG",
      "/files/images/l86201713317533.JPG",
      "/files/images/l86201713617689.JPG",
      "/files/images/l86201713917626.JPG",
      "/files/images/l862017131217424.JPG",
      "/files/images/l862017131417330.JPG",
      "/files/images/l8620171316171.JPG"
    ],
    "video": ""
  },
  {
    "id": "2b--sinifi-sinif-gunu",
    "title": "2-B  SINIFI SINIF GÜNÜ",
    "image": "/files/images/l26201713423344.JPG",
    "description": "2-B  SINIFI SINIF GÜNÜ2-B Sınıfı  \" Sınıf Günümüzü \" çoşku ve neşeyle kutladık.",
    "gallery": [
      "/files/images/l26201713423344.JPG",
      "/files/images/l262017134433497.JPG",
      "/files/images/l262017134633716.JPG",
      "/files/images/l262017134933935.JPG",
      "/files/images/l262017135233513.JPG",
      "/files/images/l262017135533310.JPG",
      "/files/images/l262017135733653.JPG",
      "/files/images/l26201713034356.JPG",
      "/files/images/l26201713234591.JPG",
      "/files/images/l26201713434419.JPG"
    ],
    "video": "https://www.youtube.com/embed/zGq_hHCkJ60?ecver=1"
  },
  {
    "id": "4-siniflar-sinif-gunu",
    "title": "4. SINIFLAR SINIF GÜNÜ",
    "image": "/files/images/l16201710104753.JPG",
    "description": "4. SINIFLAR SINIF GÜNÜ",
    "gallery": [
      "http://www.guneygelisim.k12.tr/files/images/c2952017191631315.jpg.jpg",
      "/files/images/l295201719153381.jpg"
    ],
    "video": ""
  },
  {
    "id": "3-siniflar-sinif-gunu-",
    "title": "3. SINIFLAR SINIF GÜNÜ ",
    "image": "/files/images/l305201717405620.JPG",
    "description": "3. SINIFLAR SINIF GÜNÜ3. Sınıfarın Sınıf gününü çoşkuyla kutladık.",
    "gallery": [
      "/files/images/l305201717405620.JPG",
      "/files/images/l3052017174356254.JPG",
      "/files/images/l3052017174556754.JPG",
      "/files/images/l3052017174856442.JPG",
      "/files/images/l3052017175056379.JPG",
      "/files/images/l3052017175256489.JPG",
      "/files/images/l3052017175556129.JPG",
      "/files/images/l3052017175656911.JPG",
      "/files/images/l3052017175956582.JPG"
    ],
    "video": "https://www.youtube.com/embed/_2RnHTu7CV8?ecver=1"
  },
  {
    "id": "2b-sinifi-siniflar-gunu",
    "title": "2/B SINIFI SINIFLAR GÜNÜ",
    "image": "/files/images/l3052017154319640.jpg",
    "description": "2/B SINIFI SINIFLAR GÜNÜ",
    "gallery": [
      "http://guneygelisim.k12.tr/files/images/c3052017155119250.jpg.jpg",
      "/files/images/l3052017154319640.jpg"
    ],
    "video": ""
  },
  {
    "id": "4-siniflar-sinif-gunu",
    "title": "4. SINIFLAR SINIF GÜNÜ",
    "image": "/files/images/l295201719153381.jpg",
    "description": "4. SINIFLAR SINIF GÜNÜ",
    "gallery": [
      "http://www.guneygelisim.k12.tr/files/images/c2952017191631315.jpg.jpg",
      "/files/images/l295201719153381.jpg"
    ],
    "video": ""
  },
  {
    "id": "2a--sinifi-sinif-gunu",
    "title": "2-A  SINIFI SINIF GÜNÜ",
    "image": "/files/images/l2552017122832842.JPG",
    "description": "2-A  SINIFI SINIF GÜNÜ",
    "gallery": [
      "http://guneygelisim.k12.tr/files/images/c2352017122258270.jpg.jpg",
      "/files/images/l2352017123654395.jpg"
    ],
    "video": ""
  },
  {
    "id": "3-siniflar-sinif-gunu-",
    "title": "3. SINIFLAR SINIF GÜNÜ ",
    "image": "/files/images/l25520179121115.jpg",
    "description": "3. SINIFLAR SINIF GÜNÜ3. Sınıfarın Sınıf gününü çoşkuyla kutladık.",
    "gallery": [
      "/files/images/l305201717405620.JPG",
      "/files/images/l3052017174356254.JPG",
      "/files/images/l3052017174556754.JPG",
      "/files/images/l3052017174856442.JPG",
      "/files/images/l3052017175056379.JPG",
      "/files/images/l3052017175256489.JPG",
      "/files/images/l3052017175556129.JPG",
      "/files/images/l3052017175656911.JPG",
      "/files/images/l3052017175956582.JPG"
    ],
    "video": "https://www.youtube.com/embed/_2RnHTu7CV8?ecver=1"
  },
  {
    "id": "2a--sinifi-sinif-gunu",
    "title": "2-A  SINIFI SINIF GÜNÜ",
    "image": "/files/images/l2352017123654395.jpg",
    "description": "2-A  SINIFI SINIF GÜNÜ",
    "gallery": [
      "http://guneygelisim.k12.tr/files/images/c2352017122258270.jpg.jpg",
      "/files/images/l2352017123654395.jpg"
    ],
    "video": ""
  },
  {
    "id": "1-siniflar-sinif-gunu",
    "title": "1. SINIFLAR SINIF GÜNÜ",
    "image": "/files/images/l125201795211306.JPG",
    "description": "1. SINIFLAR SINIF GÜNÜ",
    "gallery": [
      "http://www.guneygelisim.k12.tr/files/images/c85201723945930.jpg.jpg",
      "/files/images/l852017235444212.jpg"
    ],
    "video": ""
  },
  {
    "id": "1-siniflar-sinif-gunu",
    "title": "1. SINIFLAR SINIF GÜNÜ",
    "image": "/files/images/l852017235444212.jpg",
    "description": "1. SINIFLAR SINIF GÜNÜ",
    "gallery": [
      "http://www.guneygelisim.k12.tr/files/images/c85201723945930.jpg.jpg",
      "/files/images/l852017235444212.jpg"
    ],
    "video": ""
  },
  {
    "id": "ogrencimiz-ali-beyaz-in--resim-sergisi",
    "title": "Öğrencimiz Ali Beyaz ın  Resim Sergisi",
    "image": "/files/images/l55201785357633.jpg",
    "description": "Öğrencimiz Ali Beyaz ın  Resim Sergisi3. Sınıf Öğrencimiz Ali Beyaz'ın sergisini açtık kendisine çok teşekkür ediyor, başarılarının devamını diliyoruz...",
    "gallery": [
      "/files/images/l55201785357633.jpg",
      "/files/images/l55201785357854.jpg",
      "/files/images/l5520178545755.jpg",
      "/files/images/l55201785457273.jpg",
      "/files/images/l55201785457445.jpg",
      "/files/images/l55201785457617.jpg",
      "/files/images/l55201785457836.jpg",
      "/files/images/l5520171310414.jpg",
      "/files/images/l5520171310586.jpg",
      "/files/images/l5520171310742.JPG",
      "/files/images/l5520171310867.JPG",
      "/files/images/l55201713208.JPG",
      "/files/images/l5520171320180.JPG",
      "/files/images/l5520171320367.JPG",
      "/files/images/l5520171320602.JPG",
      "/files/images/l5520171320820.JPG",
      "/files/images/l552017133023.JPG",
      "/files/images/l5520171330227.JPG",
      "/files/images/l5520171330398.JPG"
    ],
    "video": ""
  },
  {
    "id": "resim-sergisi",
    "title": "Resim Sergisi",
    "image": "/files/images/l2520172233431.jpg",
    "description": "Resim Sergisi2\\A sınıfı öğrencilerimizden Osman Efe Konuk'un \"Çizgi Karakterlerim\" konulu kişisel sergisi açıldı. Çizdiği harika kahramanlar ile hayal gücünü kullanarak büyük beğeni topladı. Hayal gücün hiç bitmesin Osman Efe...",
    "gallery": [
      "/files/images/l233201712115899.JPG",
      "/files/images/l233201712135835.JPG",
      "/files/images/l2332017121358644.JPG",
      "/files/images/l2332017121558488.JPG",
      "/files/images/l2332017121658301.JPG",
      "/files/images/l2332017121858300.JPG",
      "/files/images/l2332017121958675.JPG",
      "/files/images/l23320171221584.JPG"
    ],
    "video": ""
  },
  {
    "id": "sevval-kaya-nin-kisisel-resim-sergisi",
    "title": "ŞEVVAL KAYA NIN KİŞİSEL RESİM SERGİSİ",
    "image": "/files/images/l2542017145654151.JPG",
    "description": "ŞEVVAL KAYA NIN KİŞİSEL RESİM SERGİSİOkulumuz öğrencilerinden Şevval Kaya'nın kişisel resim sergisinden kareler...",
    "gallery": [
      "/files/images/l2542017145654151.JPG",
      "/files/images/l2542017145654495.JPG",
      "/files/images/l2542017145654838.JPG",
      "/files/images/l2542017145754104.JPG",
      "/files/images/l2542017145754385.JPG",
      "/files/images/l2542017145754635.JPG",
      "/files/images/l2542017145754885.JPG",
      "/files/images/l2542017145854120.JPG",
      "/files/images/l2542017145854338.JPG",
      "/files/images/l2542017145854651.JPG",
      "/files/images/l2542017145854995.JPG",
      "/files/images/l2542017145954292.JPG",
      "/files/images/l2542017145954620.JPG",
      "/files/images/l2542017145954932.JPG",
      "/files/images/l254201714055370.JPG",
      "/files/images/l254201714055963.JPG"
    ],
    "video": ""
  },
  {
    "id": "4-sinif-ogrencimiz-sevval-kaya-nin-sergisi",
    "title": "4. Sınıf öğrencimiz Şevval Kaya nın sergisi",
    "image": "/files/images/l1542017103230648.jpg",
    "description": "4. Sınıf öğrencimiz Şevval Kaya nın sergisi4. Sınıf öğrencimiz Şevval Kaya 'nın sergisinde sizleri de aramızda görmekten mutluluk duyarız.",
    "gallery": [
      "/files/images/l1542017103230648.jpg"
    ],
    "video": ""
  },
  {
    "id": "kisisel-resim-sergisi",
    "title": "KİŞİSEL RESİM SERGİSİ",
    "image": "/files/images/l2832017134022198.jpg",
    "description": "KİŞİSEL RESİM SERGİSİ2. Sınıf Öğrencimiz Osman Efe Konuk'un \"Çizgi Karakterlerim\" Konulu resim sergisine sizleri de bekliyoruz.",
    "gallery": [
      "http://guneygelisim.k12.tr/files/images/c2132017143959850.jpg.jpg",
      "/files/images/l2132017142359304.jpg"
    ],
    "video": ""
  },
  {
    "id": "kisisel-resim-sergisi",
    "title": "KİŞİSEL RESİM SERGİSİ",
    "image": "/files/images/l243201714293430.jpg",
    "description": "KİŞİSEL RESİM SERGİSİ2. Sınıf Öğrencimiz Osman Efe Konuk'un \"Çizgi Karakterlerim\" Konulu resim sergisine sizleri de bekliyoruz.",
    "gallery": [
      "http://guneygelisim.k12.tr/files/images/c2132017143959850.jpg.jpg",
      "/files/images/l2132017142359304.jpg"
    ],
    "video": ""
  },
  {
    "id": "resim-sergisi",
    "title": "Resim Sergisi",
    "image": "/files/images/l233201712115899.JPG",
    "description": "Resim Sergisi2\\A sınıfı öğrencilerimizden Osman Efe Konuk'un \"Çizgi Karakterlerim\" konulu kişisel sergisi açıldı. Çizdiği harika kahramanlar ile hayal gücünü kullanarak büyük beğeni topladı. Hayal gücün hiç bitmesin Osman Efe...",
    "gallery": [
      "/files/images/l233201712115899.JPG",
      "/files/images/l233201712135835.JPG",
      "/files/images/l2332017121358644.JPG",
      "/files/images/l2332017121558488.JPG",
      "/files/images/l2332017121658301.JPG",
      "/files/images/l2332017121858300.JPG",
      "/files/images/l2332017121958675.JPG",
      "/files/images/l23320171221584.JPG"
    ],
    "video": ""
  },
  {
    "id": "kisisel-resim-sergisi",
    "title": "KİŞİSEL RESİM SERGİSİ",
    "image": "/files/images/l2132017142359304.jpg",
    "description": "KİŞİSEL RESİM SERGİSİ2. Sınıf Öğrencimiz Osman Efe Konuk'un \"Çizgi Karakterlerim\" Konulu resim sergisine sizleri de bekliyoruz.",
    "gallery": [
      "http://guneygelisim.k12.tr/files/images/c2132017143959850.jpg.jpg",
      "/files/images/l2132017142359304.jpg"
    ],
    "video": ""
  },
  {
    "id": "grade-4-spelling-bee",
    "title": "GRADE 4 SPELLING BEE",
    "image": "/files/images/l2132017101732832.jpg",
    "description": "GRADE 4 SPELLING BEEOkulumuzun 4. sınıflarını kapsayan  \"Spelling Bee\" adlı heceleme yarışmasında dereceye giren öğrenciler ödül olarak sinema bileti kazandılar. Katılan tüm öğrenclerimizi tebrik eder, başarılarının devamını dileriz.Our 4thgradesenjoyed participating in the 'Spelling Bee'. The winners got movie tickets as a prize. We congratulate all the students who participated.",
    "gallery": [
      "/files/images/l2132017101732832.jpg"
    ],
    "video": ""
  },
  {
    "id": "here-to-help-activity",
    "title": "HERE TO HELP ACTIVITY",
    "image": "/files/images/l213201710193181.jpg",
    "description": "HERE TO HELP ACTIVITYİngilizce Bölümümüzün \"Here to Help\" adlı proje çalışmasında , ilkokul dördüncü sınıf öğrencileri 1 hafta boyunca kendilerinden küçük öğrencilere ders aralarında çeşitli konularda yardım ettiler.Birlilkte oyun oyanayıp, okuma çalışması yapıp, eğlenceli vakit geçirdiler.We, as the English department, organized a project called 'Here to Help' which was full of activities.  Our 4thgraders helped young learners in various ways all week long.  They played games, drew pictures, did reading hours, studied English and had fun together.",
    "gallery": [
      "/files/images/l213201710193181.jpg",
      "/files/images/l2132017101931160.jpg"
    ],
    "video": ""
  },
  {
    "id": "spirit-week",
    "title": "SPIRIT WEEK",
    "image": "/files/images/l2132017105929253.jpg",
    "description": "SPIRIT WEEKİngilizce bölümünün hazırladığı 'Spirit Week' adlı etkinlik günlerinde öğrencilerimiz bir hafta boyunca günün konseptine uygun bir şekilde giyinerek yaratıcılıklarını sergileme fırsatı buldular.Dönem sonu yapılan Spirit Week etkinliğiyle öğrencilerimiz keyifli vakit geçirdiler.Our students enjoyed participating in all the Spirit Week activities.   It was a great way to wrap up the end of the first term.  They dressed up in different outfits or used items they created themselves to get involved in each day's theme.",
    "gallery": [
      "/files/images/l2132017105929253.jpg",
      "/files/images/l213201710030659.jpg",
      "/files/images/l213201710130550.jpg"
    ],
    "video": ""
  },
  {
    "id": "saglikli-beslenme-sunumu--",
    "title": "SAĞLIKLI BESLENME SUNUMU",
    "image": "/files/images/l732017151229751.JPG",
    "description": "SAĞLIKLI BESLENME SUNUMUDeğerli velimiz Beslenme ve Diyetetik Uzmanı Duygu Bilgin, İlkokul öğrencilerine, “ Yeterli ve dengeli beslenme, güne kahvaltı yaparak başlamanın önemi,  şeker, tuz ve yağ içeriği yüksek yiyecek-içecek tüketiminden kaçınma, bol su içmenin önemi, zihinsel faaliyetlerimiz için meyve yemenin önemi, doğru olmayan beslenme alışkanlıkları”  ile ilgili paylaşımda bulunmuştur. Bu sunum sonunda düzenlenen soru-cevap kısmında öğrencilerimiz akıllarına takılan soruların cevaplarını alma fırsatı bulmuşlardır. Bilgilerine yeni bilgiler kazandıran öğrencilerimize verdiği katkılardan dolayı değerli velimiz Dyt. Duygu Bilgin’e teşekkür ederiz.",
    "gallery": [
      "/files/images/l732017151229751.JPG"
    ],
    "video": ""
  },
  {
    "id": "ritmik-jimnastik-mersin-3’su",
    "title": "RİTMİK JİMNASTİK Mersin 3.’sü",
    "image": "/images2/img2_files/logo.jpg",
    "description": "RİTMİK JİMNASTİK Mersin 3.’süSevgili Öğrencimiz Duru Ekiz, 2016-2017 Eğitim-Öğretim Yılı okullar arası “RİTMİK JİMNASTİK MİNİK B KATEGORİSİNDE ”  Mersin 3.’sü oldu. Öğrencimizi kutluyor, başarılarının devamını diliyoruz.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "satranc-turnuvasi",
    "title": "SATRANÇ TURNUVASI",
    "image": "/files/images/l2722017212150602.jpg",
    "description": "SATRANÇ TURNUVASISATRANÇ TURNUVASI2016-2017 Okul Sporları Satranç Mersin İl Şampiyonası 18-19 Şubat 2017 tarihlerinde Servet Tazegül Kapalı Spor Salonunda düzenlendi. Minikler, Küçükler ve Yıldızlar kategorisinde yarışan okul takımlarımızı gösterdikleri performanslarından dolayı gönülden kutlarız.Irmak Alpsoylu, Alya Adıgüzel, Hatice Naz Solak ve Bade Tütüncü'den oluşan Minik Kız Takımımız 2. lik.Aydın Altar Güvenoğlu, Sarp Yılmaz, Rüzgar Efe Yıldırım ve Umut Cem Çiçek'ten oluşan Minik Erkek A Takımımız 3. lük.Yiğit Köprülü, Erdem Çöl, Fevzi Bora Kurt ve Kendal Zana Alp'ten oluşan Minik Erkek B takımımız 10. luk.Mehmet Eren Yüzükçü, Mehmet Eren Kahrıman, Demir Lale, Ömer Tutku Tura ve Utku Yiğit Yazıcı'dan oluşan Küçük Erkek A Takımımız 2. lik,Hasan Yozgat, İlker Özel, Arda Çokgünlü ve Efe Ahmetler'den oluşan Küçük Erkek B takımımız 3. lük.Mert Arı, Ekin Can Esen, Alper Altun ve Furkan Çirit'ten oluşan Yıldız Erkek Takımız ise 5. lik derecelerini kazandılar.Çocuklarımızı kutluyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/l2722017212150602.jpg",
      "/files/images/l2722017212150914.jpg",
      "/files/images/l2722017212250102.jpg",
      "/files/images/l2722017212250227.jpg"
    ],
    "video": ""
  },
  {
    "id": "duyuru-1-sinif-velilerimizin-dikkatine",
    "title": "DUYURU 1. SINIF VELİLERİMİZİN DİKKATİNE!",
    "image": "/images2/img2_files/logo.jpg",
    "description": "DUYURU 1. SINIF VELİLERİMİZİN DİKKATİNE!",
    "gallery": [
      "http://www.guneygelisim.k12.tr/files/images/c7122016142335634.jpg.jpg"
    ],
    "video": ""
  },
  {
    "id": "kisa-film-yarismasi-odul-toreni",
    "title": "KISA FİLM YARIŞMASI ÖDÜL TÖRENİ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "KISA FİLM YARIŞMASI ÖDÜL TÖRENİ4. sınıf öğrencimiz Koza Güven Türkiye geneli yapılan kısa film yarışmasında 4. olarak mansiyon ödülünü İstanbul 'da gerçekleştirilen ödül töreninde aldı.",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/k4H8kAasbbDJzybs5QS"
  },
  {
    "id": "anasinifi-portfolyo-sunumlari",
    "title": "ANASINIFI PORTFOLYO SUNUMLARI",
    "image": "/files/images/t_201_4492608905.jpg",
    "description": "ANASINIFI PORTFOLYO SUNUMLARIÇocuklarımız portfolyo sunumlarında çok başarılıydı.",
    "gallery": [
      "/files/images/t_201_4492608905.jpg",
      "/files/images/t_201_5966760516.jpg",
      "/files/images/t_201_9846002459.jpg"
    ],
    "video": ""
  },
  {
    "id": "23-nisan-satranc-turnuvalari",
    "title": "23 NİSAN SATRANÇ TURNUVALARI",
    "image": "/files/images/t_DSC_8261987567.JPG",
    "description": "23 NİSAN SATRANÇ TURNUVALARIMülkiyeliler Birliği tarafından 15.si organize edilen 23 Nisan Ulusal Egemenlik ve Çocuk Bayramı Satranç Turnuvası sona erdi. Okulumuz öğrencileri her yaş kategorisinde dereceye girmeyi başardı.Yarışmaya katılan ve ödül alan bütün öğrencilerimizi kutluyoruz…6 Yaş Vip Anaokuluİl 3.süUtku AracıTuna Ozan ErgünYağız GündoğanOrhan HavadarToros LeventMuhsin Uğurelİlhan Berk AngıAta Bozel Ilgaz   Gökmen7 Yaşİl 3.süOnur Efe AydemirDeniz ZanturRüzgar YıldırımAhmet Efe ÇelikYiğit KöprülüDeniz Çağın ÖzananarUtku Eren TürközUmut Cem Çiçek8 YaşŞAMPİYON Kuzey ÇakıcıHasan YozgatAltar GüvenoğluKendal Zana AlpHatice Naz SolakAli Emre YüzükçüSarp  Yılmaz8 Yaş  Kızlarİl 2siIrmak Alpsoylu9-10 Yaşİl 2.siTutku TuraMehmet Eren YüzükçüAhmet ŞifanCem YıldızKıvanç Güvenİlker ÖzelGüney ErdinçEvren Atmaca10 Yaş kızlarİl 3.süİdil Aylin TapanNur Sucu",
    "gallery": [
      "/files/images/t_DSC_8261987567.JPG",
      "/files/images/t_ima_2286798358.jpg"
    ],
    "video": ""
  },
  {
    "id": "resim-yarismasi",
    "title": "RESİM YARIŞMASI",
    "image": "/files/images/t_201_2011224628.jpg",
    "description": "RESİM YARIŞMASIOkulumuz öğrencileri \"Primo Üçgen Boya Kreatif Resim Yarışması \" na katılarak başarı belgelerini ve madalyalarını aldılar. Öğrencilerimizi tebrik ediyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/t_201_2011224628.jpg",
      "/files/images/t_DSC_5936548114.jpg"
    ],
    "video": ""
  },
  {
    "id": "buluslarin-tarihine-yolculuk",
    "title": "BULUŞLARIN TARİHİNE YOLCULUK",
    "image": "/files/images/t_DSC_6612207293.jpg",
    "description": "BULUŞLARIN TARİHİNE YOLCULUK4. sınıf öğrencilerimiz Fen Bilgisi ve Görsel Sanatlar dersi işbirliği ile hazırladıkları \"Buluşların Tarihine Yolculuk\" etkinliklerini sergilediler.Sergilerini gezen veli ve öğretmenlerine projeleri ilgili sunumlarını da yapan 4/A ve 4/B sınıfı öğrencilerimizi kutluyoruz.",
    "gallery": [
      "/files/images/t_DSC_6612207293.jpg",
      "/files/images/t_DSC_4341699481.jpg",
      "/files/images/t_DSC_2420007587.jpg",
      "/files/images/t_DSC_3036615253.jpg",
      "/files/images/t_DSC_8500329852.jpg",
      "/files/images/t_DSC_5663720965.jpg",
      "/files/images/t_DSC_4023553729.jpg",
      "/files/images/t_DSC_2986413837.jpg",
      "/files/images/t_DSC_3718530536.jpg",
      "/files/images/t_DSC_103113056.jpg",
      "/files/images/t_DSC_7739221453.jpg",
      "/files/images/t_DSC_9928705096.jpg",
      "/files/images/t_DSC_2942468524.jpg",
      "/files/images/t_DSC_6359674334.jpg",
      "/files/images/t_DSC_7047845721.jpg",
      "/files/images/t_DSC_4691888690.jpg",
      "/files/images/t_DSC_4033166766.jpg",
      "/files/images/t_DSC_9660760760.jpg",
      "/files/images/t_DSC_7293664813.jpg",
      "/files/images/t_DSC_980493427.jpg"
    ],
    "video": ""
  },
  {
    "id": "minik-erkekler-basketbol-takimimiz-ilk-galibiyetini-aldi",
    "title": "MİNİK ERKEKLER BASKETBOL TAKIMIMIZ İLK GALİBİYETİNİ ALDI",
    "image": "/files/images/t_201_7324945330.jpg",
    "description": "MİNİK ERKEKLER BASKETBOL TAKIMIMIZ İLK GALİBİYETİNİ ALDIMinik Basketbol Takımımız Doruk Sporl'u yenerek ilk galibiyetlerini aldılar.",
    "gallery": [
      "/files/images/t_201_7324945330.jpg",
      "/files/images/t_201_4809076190.jpg",
      "/files/images/t_201_3174554706.jpg",
      "/files/images/t_201_4337579608.jpg",
      "/files/images/t_201_6545068621.jpg"
    ],
    "video": ""
  },
  {
    "id": "5-siniflar-kultur-gezisi",
    "title": "5. SINIFLAR KÜLTÜR GEZİSİ",
    "image": "/files/images/t_IMG_2681848407.jpg",
    "description": "5. SINIFLAR KÜLTÜR GEZİSİ5.Sınıflarımız  Sosyal Bilgiler dersinde öğrendikleri tarihi ve kültürel değerlerimizi tanımaları amacıyla şehir müzesi ve Atatürk evi ziyaret edildi. Irmak restoranda yöresel ürünlerimizden oluşan kahvaltıda bölgemizin yemek kültürü tanıtıldı. Çevremizin coğrafi özellikleri incelenip, doğal bitki örtüsü hakkında bilgiler kazandılar.",
    "gallery": [
      "/files/images/t_IMG_2681848407.jpg",
      "/files/images/t_IMG_9640313982.jpg",
      "/files/images/t_IMG_6437951922.jpg",
      "/files/images/t_IMG_1879083515.jpg",
      "/files/images/t_IMG_7865411639.jpg",
      "/files/images/t_IMG_507623554.jpg",
      "/files/images/t_IMG_4445917010.jpg"
    ],
    "video": ""
  },
  {
    "id": "yuzme-musabakalari",
    "title": "YÜZME MÜSABAKALARI",
    "image": "/files/images/t_DSC_5570642352.jpg",
    "description": "YÜZME MÜSABAKALARI29 Ekim Cumhuriyet Bayramı Etkinlikleri kapsamında il genelinde düzenlenen yüzme müsabakalarında1. olan öğrencimiz Şira Nur Eroğlu’nu kutluyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/t_DSC_5570642352.jpg"
    ],
    "video": ""
  },
  {
    "id": "tenis-turnuvasi",
    "title": "TENİS TURNUVASI",
    "image": "/files/images/t_DSC_6044732928.jpg",
    "description": "TENİS TURNUVASIMersin Tenis Yelken ve Yüzme kulübünün düzenlediği Tenis Turnuvasında 12 Yaş Tek Erkek 7. Grup Birincisi olanHüseyin Oskay'ıve TTF 12 Yaş Tenis Turnuvasında  Tek Erkek 5. Grup İkincisiToprak Avcıbaşı'nı tebrik ediyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/t_DSC_6044732928.jpg",
      "/files/images/t_DSC_1127435565.jpg",
      "/files/images/t_DSC_1244317890.jpg",
      "/files/images/t_DSC_2734643817.jpg",
      "/files/images/t_DSC_2251855731.jpg",
      "/files/images/t_DSC_384790302.jpg"
    ],
    "video": ""
  },
  {
    "id": "resim-yarismasi",
    "title": "RESİM YARIŞMASI",
    "image": "/files/images/t_5.j_3402215839.jpg",
    "description": "RESİM YARIŞMASIOkulumuz öğrencileri \"Primo Üçgen Boya Kreatif Resim Yarışması \" na katılarak başarı belgelerini ve madalyalarını aldılar. Öğrencilerimizi tebrik ediyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/t_201_2011224628.jpg",
      "/files/images/t_DSC_5936548114.jpg"
    ],
    "video": ""
  },
  {
    "id": "bilgi-yarismasi",
    "title": "BİLGİ YARIŞMASI",
    "image": "/files/images/t_DSC_3370782733.jpg",
    "description": "BİLGİ YARIŞMASIÖğrenci meclisinin hazırladığı \" Bilgi Kültür \" yarışması 5,6,7,8 . sınıflar  arası yapıldı. Katılan arkadaşlarımıza teşekkür ediyoruz.",
    "gallery": [
      "/files/images/t_DSC_3370782733.jpg",
      "/files/images/t_DSC_6624414325.jpg",
      "/files/images/t_DSC_2666131854.jpg",
      "/files/images/t_DSC_3665429950.jpg",
      "/files/images/t_DSC_1655389667.jpg",
      "/files/images/t_DSC_2532007098.jpg",
      "/files/images/t_DSC_2212640643.jpg",
      "/files/images/t_DSC_4243738055.jpg",
      "/files/images/t_DSC_2754327655.jpg",
      "/files/images/t_DSC_6684228778.jpg"
    ],
    "video": ""
  },
  {
    "id": "deneme-sinavi-birincilerimiz",
    "title": "DENEME SINAVI BİRİNCİLERİMİZ",
    "image": "/files/images/t_D1._9928552508.jpg",
    "description": "DENEME SINAVI BİRİNCİLERİMİZ09.03.2014 tarihinde Türkiye genelinde yapılan (Farklı Yayıncılık tarafından) 3. Başarı Ölçme ve Değerlendirme Sınavında 700 tam puan alarak Türkiye 1.’si olan öğrencilerimiz Eren Kahrıman (3/A) ve Müge Cıllı (3/B) ile Türkiye 2.’si olan Ece Güngör (4/A) ve Atakan Alan’ı (4/B) kutluyor, başarılarının devamını diliyoruz.",
    "gallery": [
      "/files/images/t_D1._9928552508.jpg",
      "/files/images/t_D2._4775354266.jpg"
    ],
    "video": ""
  },
  {
    "id": "vip-kres-kahvalti-etkinligimiz",
    "title": "VİP KREŞ KAHVALTI ETKİNLİĞİMİZ",
    "image": "/files/images/t_DSC_8849145770.jpg",
    "description": "VİP KREŞ KAHVALTI ETKİNLİĞİMİZ6 yaş sınıfı öğrenci ve velilerimizle birlikte kahvaltı yapıp, güzel bir gün geçirdik. Katılan tüm velilerimize çok teşekkür ediyoruz.",
    "gallery": [
      "/files/images/t_DSC_8849145770.jpg",
      "/files/images/t_2.j_3868982196.jpg",
      "/files/images/t_3.j_5286371112.jpg",
      "/files/images/t_4.j_8475915789.jpg",
      "/files/images/t_5.j_7977868914.jpg",
      "/files/images/t_6.j_8674737811.jpg",
      "/files/images/t_7.j_7065393328.jpg",
      "/files/images/t_8.j_5252954364.jpg",
      "/files/images/t_9.j_2692987323.jpg",
      "/files/images/t_10._8228723406.jpg",
      "/files/images/t_11._7672082782.jpg"
    ],
    "video": ""
  },
  {
    "id": "antalya-kampi-4gun",
    "title": "ANTALYA KAMPI 4.GÜN",
    "image": "/images2/img2_files/logo.jpg",
    "description": "ANTALYA KAMPI 4.GÜN",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/x1b2kr6"
  },
  {
    "id": "antalya-kampi",
    "title": "ANTALYA KAMPI",
    "image": "/files/images/t_1.j_3981897235.jpg",
    "description": "ANTALYA KAMPISayın Velilerimiz;8. Sınıf kamp görüntülerinin tamamını görmek için2013 - 2014 Kamp Görüntüleri'ne tıklayınız.",
    "gallery": [
      "/files/images/t_1.j_3981897235.jpg",
      "/files/images/t_2.j_1244623065.jpg",
      "/files/images/t_4.j_2344934345.jpg",
      "/files/images/t_5.j_824701190.jpg",
      "/files/images/t_5.j_8829767108.jpg",
      "/files/images/t_6.j_7423517108.jpg",
      "/files/images/t_7.j_1599695087.jpg",
      "/files/images/t_8.j_2808496356.jpg",
      "/files/images/t_9.j_6298944354.jpg",
      "/files/images/t_10._7721979022.jpg",
      "/files/images/t_12._6963159442.jpg",
      "/files/images/t_13._1990167499.jpg",
      "/files/images/t_14._4338037372.jpg",
      "/files/images/t_15._5112115741.jpg",
      "/files/images/t_17._34906269.jpg",
      "/files/images/t_18._287896991.jpg"
    ],
    "video": ""
  },
  {
    "id": "8siniflar-antalya-kampi",
    "title": "8.SINIFLAR ANTALYA KAMPI",
    "image": "/images2/img2_files/logo.jpg",
    "description": "8.SINIFLAR ANTALYA KAMPI",
    "gallery": [],
    "video": ""
  },
  {
    "id": "8siniflar-3gun-kamp-videosu",
    "title": "8.SINIFLAR 3.GÜN KAMP VİDEOSU",
    "image": "/images2/img2_files/logo.jpg",
    "description": "8.SINIFLAR 3.GÜN KAMP VİDEOSU",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/x1avgxz"
  },
  {
    "id": "8-siniflar-antalya-kampi-2gun-videosu",
    "title": "8. SINIFLAR ANTALYA KAMPI 2.GÜN VİDEOSU",
    "image": "/images2/img2_files/logo.jpg",
    "description": "8. SINIFLAR ANTALYA KAMPI 2.GÜN VİDEOSU",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/x1apgwh"
  },
  {
    "id": "enerji-tasarrufu-haftasi",
    "title": "ENERJİ TASARRUFU HAFTASI",
    "image": "/files/images/t_2.j_5449029803.jpg",
    "description": "ENERJİ TASARRUFU HAFTASIOcak ayının ikinci haftası olan \"Enerji Tasarrufu Haftası\" nı işledik. 3. ve 4. sınıflarımız \"Enerjinin gereği, bilinçli olarak kullanılmasının önemini\" belirttikleri güzel cümleler ve resimlerle harika bir pano oluşturarak ifade ettiler.",
    "gallery": [
      "/files/images/t_2.j_5449029803.jpg",
      "/files/images/t_3.j_185510517.jpg",
      "/files/images/t_4.j_8531915545.jpg",
      "/files/images/t_5.j_2508203388.jpg"
    ],
    "video": ""
  },
  {
    "id": "ilkogretim-yeni-yil-etkinligi",
    "title": "İLKÖĞRETİM YENİ YIL ETKİNLİĞİ",
    "image": "/files/images/t_1.j_615808368.jpg",
    "description": "İLKÖĞRETİM YENİ YIL ETKİNLİĞİ28 Aralık Cumartesi günü 1. Kademe öğrencilerimizle Hilton Oteli'nde \"Yeni Yıla Merhaba\" dedik.",
    "gallery": [
      "/files/images/t_1.j_615808368.jpg",
      "/files/images/t_2.j_9577447772.jpg",
      "/files/images/t_3.j_9061242938.jpg",
      "/files/images/t_4.j_1318475604.jpg",
      "/files/images/t_5.j_3047906757.jpg",
      "/files/images/t_6.j_2062188983.jpg",
      "/files/images/t_7.j_5678979754.jpg",
      "/files/images/t_8.j_5740014911.jpg",
      "/files/images/t_9.j_4920160174.jpg",
      "/files/images/t_10._8384515643.jpg",
      "/files/images/t_10._3090173602.jpg",
      "/files/images/t_11._4339410663.jpg",
      "/files/images/t_12._1846429706.jpg",
      "/files/images/t_13._3078576923.jpg"
    ],
    "video": ""
  },
  {
    "id": "yeni-yila-merhaba",
    "title": "YENİ YILA MERHABA",
    "image": "/files/images/t_1.j_3374597430.jpg",
    "description": "YENİ YILA MERHABAKutlamalarımız devam ediyor. 1. Sınıflar olarak okulumuzda yaptığımız parti de harikaydı.Herkese Mutlu Yıllar.....",
    "gallery": [
      "/files/images/t_1.j_3374597430.jpg",
      "/files/images/t_2.j_9222833514.jpg",
      "/files/images/t_3.j_6235010028.jpg",
      "/files/images/t_4.j_958825946.jpg",
      "/files/images/t_5.j_7284051776.jpg",
      "/files/images/t_6.j_6311456561.jpg",
      "/files/images/t_7.j_1303216815.jpg",
      "/files/images/t_8.j_3875543475.jpg"
    ],
    "video": ""
  },
  {
    "id": "resim-sergimiz",
    "title": "RESİM SERGİMİZ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "RESİM SERGİMİZ",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/xzfmy4"
  },
  {
    "id": "hayvanlari-koruma-gunu",
    "title": "HAYVANLARI KORUMA GÜNÜ",
    "image": "/files/images/t_2.j_1025964618.jpg",
    "description": "HAYVANLARI KORUMA GÜNÜ3. Sınıflarımız 7.10.2013 günüyaptıkları kermesten elde ettikleri gelirle \"Mersin Üniversitesi HayvanBarınağını\"ziyaret edip, aldıkları yiyecekleri görevlilere teslim ettiler. 3.Sınıflarımıza yaptıkları bu çalışmalar için teşekkür ediyoruz.ÖĞRENCİ MECLİSİ",
    "gallery": [
      "/files/images/t_2.j_1025964618.jpg",
      "/files/images/t_3.j_6853143573.jpg",
      "/files/images/t_5.j_7662927508.jpg",
      "/files/images/t_6.j_9749109149.jpg",
      "/files/images/t_7.j_420648456.jpg"
    ],
    "video": ""
  },
  {
    "id": "10-kasim-ataturku-anma-gunu-",
    "title": "10 KASIM ATATÜRK`Ü ANMA GÜNÜ ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "10 KASIM ATATÜRK`Ü ANMA GÜNÜ10KASIMileguneygelisimkoleji",
    "gallery": [],
    "video": "http://www.dailymotion.com/embed/video/xzp4xm"
  },
  {
    "id": "2tip-bayrami-satranc-turnuvasi",
    "title": "2.Tıp Bayramı Satranç Turnuvası",
    "image": "/files/images/t_DSC_1884729266.JPG",
    "description": "2.Tıp Bayramı Satranç TurnuvasıMersin Tabipler Odasının düzenlemiş olduğu 2.Tıp Bayramı Satranç Turnuvasında ödül alan öğrencilerimizi kutlar,başarılarının devamını dileriz.",
    "gallery": [
      "/files/images/t_DSC_1884729266.JPG"
    ],
    "video": ""
  },
  {
    "id": "istiklal-marsinin-kabulu",
    "title": "İstiklal Marşının Kabulü",
    "image": "/images2/img2_files/logo.jpg",
    "description": "İstiklal Marşının Kabulü",
    "gallery": [],
    "video": ""
  },
  {
    "id": "ingilizce-show",
    "title": "İNGİLİZCE SHOW",
    "image": "/images2/img2_files/logo.jpg",
    "description": "İNGİLİZCE SHOW05 Nisan 2013 Cuma Günü Saat 19.00'da İngilizce Gecesi Düzenlenecektir.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "genel-tanitim",
    "title": "Genel Tanıtım",
    "image": "/images2/img2_files/logo.jpg",
    "description": "Genel Tanıtım12 Nisan 2013 Cuma saat 18.00 Genel Tanıtım",
    "gallery": [],
    "video": ""
  },
  {
    "id": "6snf-veli-toplanti",
    "title": "6.SNF VELİ TOPLANTI",
    "image": "/images2/img2_files/logo.jpg",
    "description": "6.SNF VELİ TOPLANTI6/A-8/A-8/B : 09 Mart 2013 Cumartesi Saat : 16.30",
    "gallery": [],
    "video": ""
  },
  {
    "id": "veli-toplantisi",
    "title": "VELİ TOPLANTISI",
    "image": "/images2/img2_files/logo.jpg",
    "description": "VELİ TOPLANTISI5/B : 05 Mart 2013 Salı Saat 16.30",
    "gallery": [],
    "video": ""
  },
  {
    "id": "veli-toplantisi",
    "title": "VELİ TOPLANTISI",
    "image": "/images2/img2_files/logo.jpg",
    "description": "VELİ TOPLANTISI5/B : 05 Mart 2013 Salı Saat 16.30",
    "gallery": [],
    "video": ""
  },
  {
    "id": "veli-toplantisi",
    "title": "VELİ TOPLANTISI",
    "image": "/images2/img2_files/logo.jpg",
    "description": "VELİ TOPLANTISI5/B : 05 Mart 2013 Salı Saat 16.30",
    "gallery": [],
    "video": ""
  },
  {
    "id": "veli-toplantisi",
    "title": "VELİ TOPLANTISI",
    "image": "/images2/img2_files/logo.jpg",
    "description": "VELİ TOPLANTISI5/B : 05 Mart 2013 Salı Saat 16.30",
    "gallery": [],
    "video": ""
  },
  {
    "id": "eylul-tum-ogretmenlerin-guz-donemi-seminer-calismalari",
    "title": "Eylül Tüm Öğretmenlerin güz dönemi seminer çalışmaları.",
    "image": "/images2/img2_files/logo.jpg",
    "description": "Eylül Tüm Öğretmenlerin güz dönemi seminer çalışmaları.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "1-temmuz-2013-ogretmenlerin-tatile-girmesi",
    "title": "1 Temmuz 2013 Öğretmenlerin tatile girmesi.",
    "image": "/images2/img2_files/logo.jpg",
    "description": "1 Temmuz 2013 Öğretmenlerin tatile girmesi.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "yaz-donemi-seminer-calismalari",
    "title": "Yaz Dönemi seminer çalışmaları",
    "image": "/images2/img2_files/logo.jpg",
    "description": "Yaz Dönemi seminer çalışmaları",
    "gallery": [],
    "video": ""
  },
  {
    "id": "ram-ile-ilgili-calisma-raporlarinin-hazirlanip-gonderilmesi",
    "title": "RAM ile ilgili çalışma raporlarının hazırlanıp gönderilmesi.",
    "image": "/images2/img2_files/logo.jpg",
    "description": "RAM ile ilgili çalışma raporlarının hazırlanıp gönderilmesi.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "sube-ogretmenler-kurulu-toplantilarinin-yapilmasi",
    "title": "Şube Öğretmenler Kurulu Toplantılarının yapılması.",
    "image": "/images2/img2_files/logo.jpg",
    "description": "Şube Öğretmenler Kurulu Toplantılarının yapılması.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "cevre-koruma-haftasi",
    "title": "Çevre Koruma Haftası",
    "image": "/images2/img2_files/logo.jpg",
    "description": "Çevre Koruma Haftası",
    "gallery": [],
    "video": ""
  },
  {
    "id": "bilim-ve-teknoloji-haftasi",
    "title": "Bilim ve Teknoloji Haftası",
    "image": "/images2/img2_files/logo.jpg",
    "description": "Bilim ve Teknoloji Haftası",
    "gallery": [],
    "video": ""
  },
  {
    "id": "girisimcilik-haftasi",
    "title": "Girişimcilik Haftası",
    "image": "/images2/img2_files/logo.jpg",
    "description": "Girişimcilik Haftası",
    "gallery": [],
    "video": ""
  },
  {
    "id": "2donem-ogretmenler-kurulu-toplantisinin-yapilmasi",
    "title": "2.Dönem Öğretmenler Kurulu Toplantısının yapılması.",
    "image": "/images2/img2_files/logo.jpg",
    "description": "2.Dönem Öğretmenler Kurulu Toplantısının yapılması.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "2donemin-baslamasi-11-subat-2013-pazartesi",
    "title": "2.Dönemin başlaması 11 şubat 2013 pazartesi.",
    "image": "/images2/img2_files/logo.jpg",
    "description": "2.Dönemin başlaması 11 şubat 2013 pazartesi.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "1-siniflar-okuma-bayramini-kutladi",
    "title": "1. SINIFLAR OKUMA BAYRAMINI KUTLADI.",
    "image": "/files/images/t_DSC_5844690204.JPG",
    "description": "1. SINIFLAR OKUMA BAYRAMINI KUTLADI.OKUMA BAYRAMINI KUTLADIKGelişim Koleji 1-A ve 1-B sınıfları, Okuma Bayramı'nı büyük bir sevinç ve heyecanla pasta keserek,eğlenerek kutladı.Bizler birinci sınıflar olarak sözümüzde durduk ve durmaya da devam edeceğiz.Hayatı anlamlı bir bütün haline getirmeye devam ediyoruz.Okulumuzda kurallara uyarak,derslerimizi çok iyi dinleyerek, sorumluluklarımızı en iyi şekilde yerine getirerek, okuma yazmayı hepimiz söktük.Bunun sevincini ve heyecanını tüm sevdiklerimizle paylaştık.Daha işimizin bitmediğinin bilincindeyiz.Bundan sonraki zamanlarda da daha çok çalışacağız ve kurallara daha çok uyup başarılarımıza daha çok başarılar katacağız.Bizleri bu günlere getiren tüm büyüklerimize ve okulumuza minnettarız.Onlara sevgilerin ve saygıların en büyüğünü sunuyoruz.İyi ki varsınız.Hepinizi çok seviyor ve saygılar sunuyoruz.1-A ve 1-B sınıfı öğrencileri",
    "gallery": [
      "/files/images/t_DSC_5844690204.JPG",
      "/files/images/t_DSC_4117395282.JPG",
      "/files/images/t_DSC_3608362079.JPG",
      "/files/images/t_DSC_9556238055.JPG",
      "/files/images/t_DSC_3107263446.JPG",
      "/files/images/t_DSC_6861078143.JPG"
    ],
    "video": ""
  },
  {
    "id": "saglikli-beslenme-semineri",
    "title": "SAĞLIKLI BESLENME SEMİNERİ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "SAĞLIKLI BESLENME SEMİNERİ﻿﻿﻿﻿(AYFER DURAN)SAĞLIKLI BESLENME SEMİNERİ",
    "gallery": [],
    "video": ""
  },
  {
    "id": "milli-kutuphane-gezisi",
    "title": "MİLLİ KÜTÜPHANE GEZİSİ",
    "image": "/images2/img2_files/logo.jpg",
    "description": "MİLLİ KÜTÜPHANE GEZİSİ(SOSYAL BİLGİLER BÖLÜMÜ)",
    "gallery": [],
    "video": ""
  },
  {
    "id": "4a-ve-4b-fen-ve-teknoloji-dersi-sunumu",
    "title": "4-A ve 4-B FEN ve TEKNOLOJİ DERSİ SUNUMU",
    "image": "/files/images/t_Fot_8532831072.jpg",
    "description": "4-A ve 4-B FEN ve TEKNOLOJİ DERSİ SUNUMUFEN ve TEKNOLOJİ DERSİ SUNUMU3 Ekim 2012 Çarşamba günü, okulumuzun salonunda, okulumuzun velilerinden olan Mersin Üniversitesi Anatomi Ana Bilim Dalı Başkanı Prof.Dr Mustafa Aktekin Bey’i konuk ettik.Prof.Dr. Mustafa Bey, 4-A ve 4-B sınıfının Fen ve Teknoloji dersinin “Vücudumuzun Bilmecesini Çözelim “ ünitesinin “Destek ve Hareket” konusu ile ilgili olarak bir sunum yaptı. Sunum, gerçek insan kemikleri, kas , omurga, eklem modelleri gibi araçlarla desteklendiği için çok keyifli ve anlaşılır olarak gerçekleşti.Derslerde işlediğimiz konulara yapılan bu katkı, üniteyi daha iyi ve kalıcı olarak öğrenmemizi sağladı.Prof. Dr Mustafa Aktekin Bey’e katkılarından ötürü teşekkür ediyoruz, ünite ile ilgili gelecekte de ihtiyaç duyduğumuzda katkılarını bekliyoruz. 4-A ve 4-B sınıfı öğrencileri ve öğretmenleri.",
    "gallery": [
      "/files/images/t_Fot_8532831072.jpg",
      "/files/images/t_Fot_2097436786.jpg",
      "/files/images/t_Fot_522882343.jpg",
      "/files/images/t_Fot_8929559588.jpg",
      "/files/images/t_Fot_5109369159.jpg",
      "/files/images/t_Fot_6938135028.jpg"
    ],
    "video": ""
  }
];
